const sicCodes = [
  {
    'Four Digit SIC Codes': 111,
    'Four Digit SIC Code Descriptions': 'WHEAT',
  },
  {
    'Four Digit SIC Codes': 112,
    'Four Digit SIC Code Descriptions': 'RICE',
  },
  {
    'Four Digit SIC Codes': 115,
    'Four Digit SIC Code Descriptions': 'CORN',
  },
  {
    'Four Digit SIC Codes': 116,
    'Four Digit SIC Code Descriptions': 'SOYBEANS',
  },
  {
    'Four Digit SIC Codes': 119,
    'Four Digit SIC Code Descriptions': 'CASH GRAINS, NEC',
  },
  {
    'Four Digit SIC Codes': 131,
    'Four Digit SIC Code Descriptions': 'COTTON',
  },
  {
    'Four Digit SIC Codes': 132,
    'Four Digit SIC Code Descriptions': 'TOBACCO',
  },
  {
    'Four Digit SIC Codes': 133,
    'Four Digit SIC Code Descriptions': 'SUGARCANE AND SUGAR BEETS',
  },
  {
    'Four Digit SIC Codes': 134,
    'Four Digit SIC Code Descriptions': 'IRISH POTATOES',
  },
  {
    'Four Digit SIC Codes': 139,
    'Four Digit SIC Code Descriptions': 'FIELD CROPS, EXCEPT CASH GRAIN',
  },
  {
    'Four Digit SIC Codes': 161,
    'Four Digit SIC Code Descriptions': 'VEGETABLES AND MELONS',
  },
  {
    'Four Digit SIC Codes': 171,
    'Four Digit SIC Code Descriptions': 'BERRY CROPS',
  },
  {
    'Four Digit SIC Codes': 172,
    'Four Digit SIC Code Descriptions': 'GRAPES',
  },
  {
    'Four Digit SIC Codes': 173,
    'Four Digit SIC Code Descriptions': 'TREE NUTS',
  },
  {
    'Four Digit SIC Codes': 174,
    'Four Digit SIC Code Descriptions': 'CITRUS FRUITS',
  },
  {
    'Four Digit SIC Codes': 175,
    'Four Digit SIC Code Descriptions': 'DECIDUOUS TREE FRUITS',
  },
  {
    'Four Digit SIC Codes': 179,
    'Four Digit SIC Code Descriptions': 'FRUITS AND TREE NUTS, NEC',
  },
  {
    'Four Digit SIC Codes': 181,
    'Four Digit SIC Code Descriptions': 'ORNAMENTAL NURSERY PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 182,
    'Four Digit SIC Code Descriptions': 'FOOD CROPS GROWN UNDER COVER',
  },
  {
    'Four Digit SIC Codes': 191,
    'Four Digit SIC Code Descriptions': 'GENERAL FARMS, PRIMARILY CROP',
  },
  {
    'Four Digit SIC Codes': 211,
    'Four Digit SIC Code Descriptions': 'BEEF CATTLE FEEDLOTS',
  },
  {
    'Four Digit SIC Codes': 212,
    'Four Digit SIC Code Descriptions': 'BEEF CATTLE, EXCEPT FEEDLOTS',
  },
  {
    'Four Digit SIC Codes': 213,
    'Four Digit SIC Code Descriptions': 'HOGS',
  },
  {
    'Four Digit SIC Codes': 214,
    'Four Digit SIC Code Descriptions': 'SHEEP AND GOATS',
  },
  {
    'Four Digit SIC Codes': 219,
    'Four Digit SIC Code Descriptions': 'GENERAL LIVESTOCK, NEC',
  },
  {
    'Four Digit SIC Codes': 241,
    'Four Digit SIC Code Descriptions': 'DAIRY FARMS',
  },
  {
    'Four Digit SIC Codes': 251,
    'Four Digit SIC Code Descriptions': 'BROILER, FRYER, AND ROASTER CHICKENS',
  },
  {
    'Four Digit SIC Codes': 252,
    'Four Digit SIC Code Descriptions': 'CHICKEN EGGS',
  },
  {
    'Four Digit SIC Codes': 253,
    'Four Digit SIC Code Descriptions': 'TURKEYS AND TURKEY EGGS',
  },
  {
    'Four Digit SIC Codes': 254,
    'Four Digit SIC Code Descriptions': 'POULTRY HATCHERIES',
  },
  {
    'Four Digit SIC Codes': 259,
    'Four Digit SIC Code Descriptions': 'POULTRY AND EGGS, NEC',
  },
  {
    'Four Digit SIC Codes': 271,
    'Four Digit SIC Code Descriptions': 'FUR-BEARING ANIMALS AND RABBITS',
  },
  {
    'Four Digit SIC Codes': 272,
    'Four Digit SIC Code Descriptions': 'HORSES AND OTHER EQUINES',
  },
  {
    'Four Digit SIC Codes': 273,
    'Four Digit SIC Code Descriptions': 'ANIMAL AQUACULTURE',
  },
  {
    'Four Digit SIC Codes': 279,
    'Four Digit SIC Code Descriptions': 'ANIMAL SPECIALTIES, NEC',
  },
  {
    'Four Digit SIC Codes': 291,
    'Four Digit SIC Code Descriptions': 'GENERAL FARMS, PRIMARILY ANIMALS',
  },
  {
    'Four Digit SIC Codes': 711,
    'Four Digit SIC Code Descriptions': 'SOIL PREPARATION SERVICES',
  },
  {
    'Four Digit SIC Codes': 721,
    'Four Digit SIC Code Descriptions': 'CROP PLANTING AND PROTECTION',
  },
  {
    'Four Digit SIC Codes': 722,
    'Four Digit SIC Code Descriptions': 'CROP HARVESTING',
  },
  {
    'Four Digit SIC Codes': 723,
    'Four Digit SIC Code Descriptions': 'CROP PREPARATION SERVICES FOR MARKET',
  },
  {
    'Four Digit SIC Codes': 724,
    'Four Digit SIC Code Descriptions': 'COTTON GINNING',
  },
  {
    'Four Digit SIC Codes': 741,
    'Four Digit SIC Code Descriptions': 'VETERINARY SERVICES FOR LIVESTOCK',
  },
  {
    'Four Digit SIC Codes': 742,
    'Four Digit SIC Code Descriptions': 'VETERINARY SERVICES, SPECIALTIES',
  },
  {
    'Four Digit SIC Codes': 751,
    'Four Digit SIC Code Descriptions': 'LIVESTOCK SERVICES, EXCEPT VETERINARY',
  },
  {
    'Four Digit SIC Codes': 752,
    'Four Digit SIC Code Descriptions': 'ANIMAL SPECIALTY SERVICES',
  },
  {
    'Four Digit SIC Codes': 761,
    'Four Digit SIC Code Descriptions': 'FARM LABOR CONTRACTORS',
  },
  {
    'Four Digit SIC Codes': 762,
    'Four Digit SIC Code Descriptions': 'FARM MANAGEMENT SERVICES',
  },
  {
    'Four Digit SIC Codes': 781,
    'Four Digit SIC Code Descriptions': 'LANDSCAPE COUNSELING AND PLANNING',
  },
  {
    'Four Digit SIC Codes': 782,
    'Four Digit SIC Code Descriptions': 'LAWN AND GARDEN SERVICES',
  },
  {
    'Four Digit SIC Codes': 783,
    'Four Digit SIC Code Descriptions': 'ORNAMENTAL SHRUB AND TREE SERVICES',
  },
  {
    'Four Digit SIC Codes': 811,
    'Four Digit SIC Code Descriptions': 'TIMBER TRACTS',
  },
  {
    'Four Digit SIC Codes': 831,
    'Four Digit SIC Code Descriptions': 'FOREST PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 851,
    'Four Digit SIC Code Descriptions': 'FORESTRY SERVICES',
  },
  {
    'Four Digit SIC Codes': 912,
    'Four Digit SIC Code Descriptions': 'FINFISH',
  },
  {
    'Four Digit SIC Codes': 913,
    'Four Digit SIC Code Descriptions': 'SHELLFISH',
  },
  {
    'Four Digit SIC Codes': 919,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS MARINE PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 921,
    'Four Digit SIC Code Descriptions': 'FISH HATCHERIES AND PRESERVES',
  },
  {
    'Four Digit SIC Codes': 971,
    'Four Digit SIC Code Descriptions': 'HUNTING, TRAPPING, GAME PROPAGATION',
  },
  {
    'Four Digit SIC Codes': 1011,
    'Four Digit SIC Code Descriptions': 'IRON ORES',
  },
  {
    'Four Digit SIC Codes': 1021,
    'Four Digit SIC Code Descriptions': 'COPPER ORES',
  },
  {
    'Four Digit SIC Codes': 1031,
    'Four Digit SIC Code Descriptions': 'LEAD AND ZINC ORES',
  },
  {
    'Four Digit SIC Codes': 1041,
    'Four Digit SIC Code Descriptions': 'GOLD ORES',
  },
  {
    'Four Digit SIC Codes': 1044,
    'Four Digit SIC Code Descriptions': 'SILVER ORES',
  },
  {
    'Four Digit SIC Codes': 1061,
    'Four Digit SIC Code Descriptions': 'FERROALLOY ORES, EXCEPT VANADIUM',
  },
  {
    'Four Digit SIC Codes': 1081,
    'Four Digit SIC Code Descriptions': 'METAL MINING SERVICES',
  },
  {
    'Four Digit SIC Codes': 1094,
    'Four Digit SIC Code Descriptions': 'URANIUM-RADIUM-VANADIUM ORES',
  },
  {
    'Four Digit SIC Codes': 1099,
    'Four Digit SIC Code Descriptions': 'METAL ORES, NEC',
  },
  {
    'Four Digit SIC Codes': 1221,
    'Four Digit SIC Code Descriptions': 'BITUMINOUS COAL AND LIGNITE-SURFACE MINING',
  },
  {
    'Four Digit SIC Codes': 1222,
    'Four Digit SIC Code Descriptions': 'BITUMINOUS COAL-UNDERGROUND MINING',
  },
  {
    'Four Digit SIC Codes': 1231,
    'Four Digit SIC Code Descriptions': 'ANTHRACITE MINING',
  },
  {
    'Four Digit SIC Codes': 1241,
    'Four Digit SIC Code Descriptions': 'COAL MINING SERVICES',
  },
  {
    'Four Digit SIC Codes': 1311,
    'Four Digit SIC Code Descriptions': 'CRUDE PETROLEUM AND NATURAL GAS',
  },
  {
    'Four Digit SIC Codes': 1321,
    'Four Digit SIC Code Descriptions': 'NATURAL GAS LIQUIDS',
  },
  {
    'Four Digit SIC Codes': 1381,
    'Four Digit SIC Code Descriptions': 'DRILLING OIL AND GAS WELLS',
  },
  {
    'Four Digit SIC Codes': 1382,
    'Four Digit SIC Code Descriptions': 'OIL AND GAS EXPLORATION SERVICES',
  },
  {
    'Four Digit SIC Codes': 1389,
    'Four Digit SIC Code Descriptions': 'OIL AND GAS FIELD SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 1411,
    'Four Digit SIC Code Descriptions': 'DIMENSION STONE',
  },
  {
    'Four Digit SIC Codes': 1422,
    'Four Digit SIC Code Descriptions': 'CRUSHED AND BROKEN LIMESTONE',
  },
  {
    'Four Digit SIC Codes': 1423,
    'Four Digit SIC Code Descriptions': 'CRUSHED AND BROKEN GRANITE',
  },
  {
    'Four Digit SIC Codes': 1429,
    'Four Digit SIC Code Descriptions': 'CRUSHED AND BROKEN STONE, NEC',
  },
  {
    'Four Digit SIC Codes': 1442,
    'Four Digit SIC Code Descriptions': 'CONSTRUCTION SAND AND GRAVEL',
  },
  {
    'Four Digit SIC Codes': 1446,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL SAND',
  },
  {
    'Four Digit SIC Codes': 1455,
    'Four Digit SIC Code Descriptions': 'KAOLIN AND BALL CLAY',
  },
  {
    'Four Digit SIC Codes': 1459,
    'Four Digit SIC Code Descriptions': 'CLAY AND RELATED MINERALS, NEC',
  },
  {
    'Four Digit SIC Codes': 1474,
    'Four Digit SIC Code Descriptions': 'POTASH, SODA, AND BORATE MINERALS',
  },
  {
    'Four Digit SIC Codes': 1475,
    'Four Digit SIC Code Descriptions': 'PHOSPHATE ROCK',
  },
  {
    'Four Digit SIC Codes': 1479,
    'Four Digit SIC Code Descriptions': 'CHEMICAL AND FERTILIZER MINING',
  },
  {
    'Four Digit SIC Codes': 1481,
    'Four Digit SIC Code Descriptions': 'NONMETALLIC MINERAL SERVICES',
  },
  {
    'Four Digit SIC Codes': 1499,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS NONMETALLIC MINING',
  },
  {
    'Four Digit SIC Codes': 1521,
    'Four Digit SIC Code Descriptions': 'SINGLE-FAMILY HOUSING CONSTRUCTION',
  },
  {
    'Four Digit SIC Codes': 1522,
    'Four Digit SIC Code Descriptions': 'RESIDENTIAL CONSTRUCTION, NEC',
  },
  {
    'Four Digit SIC Codes': 1531,
    'Four Digit SIC Code Descriptions': 'OPERATIVE BUILDERS',
  },
  {
    'Four Digit SIC Codes': 1541,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL BUILDINGS AND WAREHOUSES',
  },
  {
    'Four Digit SIC Codes': 1542,
    'Four Digit SIC Code Descriptions': 'NONRESIDENTIAL CONSTRUCTION, NEC',
  },
  {
    'Four Digit SIC Codes': 1611,
    'Four Digit SIC Code Descriptions': 'HIGHWAY AND STREET CONSTRUCTION',
  },
  {
    'Four Digit SIC Codes': 1622,
    'Four Digit SIC Code Descriptions': 'BRIDGE, TUNNEL, AND ELEVATED HIGHWAY',
  },
  {
    'Four Digit SIC Codes': 1623,
    'Four Digit SIC Code Descriptions': 'WATER, SEWER, AND UTILITY LINES',
  },
  {
    'Four Digit SIC Codes': 1629,
    'Four Digit SIC Code Descriptions': 'HEAVY CONSTRUCTION, NEC',
  },
  {
    'Four Digit SIC Codes': 1711,
    'Four Digit SIC Code Descriptions': 'PLUMBING, HEATING, AIR-CONDITIONING',
  },
  {
    'Four Digit SIC Codes': 1721,
    'Four Digit SIC Code Descriptions': 'PAINTING AND PAPER HANGING',
  },
  {
    'Four Digit SIC Codes': 1731,
    'Four Digit SIC Code Descriptions': 'ELECTRICAL WORK',
  },
  {
    'Four Digit SIC Codes': 1741,
    'Four Digit SIC Code Descriptions': 'MASONRY AND OTHER STONEWORK',
  },
  {
    'Four Digit SIC Codes': 1742,
    'Four Digit SIC Code Descriptions': 'PLASTERING, DRYWALL, AND INSULATION',
  },
  {
    'Four Digit SIC Codes': 1743,
    'Four Digit SIC Code Descriptions': 'TERRAZZO, TILE, MARBLE, MOSAIC WORK',
  },
  {
    'Four Digit SIC Codes': 1751,
    'Four Digit SIC Code Descriptions': 'CARPENTRY WORK',
  },
  {
    'Four Digit SIC Codes': 1752,
    'Four Digit SIC Code Descriptions': 'FLOOR LAYING AND FLOOR WORK, NEC',
  },
  {
    'Four Digit SIC Codes': 1761,
    'Four Digit SIC Code Descriptions': 'ROOFING, SIDING, AND SHEETMETAL WORK',
  },
  {
    'Four Digit SIC Codes': 1771,
    'Four Digit SIC Code Descriptions': 'CONCRETE WORK',
  },
  {
    'Four Digit SIC Codes': 1781,
    'Four Digit SIC Code Descriptions': 'WATER WELL DRILLING',
  },
  {
    'Four Digit SIC Codes': 1791,
    'Four Digit SIC Code Descriptions': 'STRUCTURAL STEEL ERECTION',
  },
  {
    'Four Digit SIC Codes': 1793,
    'Four Digit SIC Code Descriptions': 'GLASS AND GLAZING WORK',
  },
  {
    'Four Digit SIC Codes': 1794,
    'Four Digit SIC Code Descriptions': 'EXCAVATION WORK',
  },
  {
    'Four Digit SIC Codes': 1795,
    'Four Digit SIC Code Descriptions': 'WRECKING AND DEMOLITION WORK',
  },
  {
    'Four Digit SIC Codes': 1796,
    'Four Digit SIC Code Descriptions': 'INSTALLING BUILDING EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 1799,
    'Four Digit SIC Code Descriptions': 'SPECIAL TRADE CONTRACTORS, NEC',
  },
  {
    'Four Digit SIC Codes': 2011,
    'Four Digit SIC Code Descriptions': 'MEAT PACKING PLANTS',
  },
  {
    'Four Digit SIC Codes': 2013,
    'Four Digit SIC Code Descriptions': 'SAUSAGES AND OTHER PREPARED MEATS',
  },
  {
    'Four Digit SIC Codes': 2015,
    'Four Digit SIC Code Descriptions': 'POULTRY SLAUGHTERING AND PROCESSING',
  },
  {
    'Four Digit SIC Codes': 2021,
    'Four Digit SIC Code Descriptions': 'CREAMERY BUTTER',
  },
  {
    'Four Digit SIC Codes': 2022,
    'Four Digit SIC Code Descriptions': 'CHEESE; NATURAL AND PROCESSED',
  },
  {
    'Four Digit SIC Codes': 2023,
    'Four Digit SIC Code Descriptions': 'DRY, CONDENSED, EVAPORATED PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2024,
    'Four Digit SIC Code Descriptions': 'ICE CREAM AND FROZEN DESERTS',
  },
  {
    'Four Digit SIC Codes': 2026,
    'Four Digit SIC Code Descriptions': 'FLUID MILK',
  },
  {
    'Four Digit SIC Codes': 2032,
    'Four Digit SIC Code Descriptions': 'CANNED SPECIALTIES',
  },
  {
    'Four Digit SIC Codes': 2033,
    'Four Digit SIC Code Descriptions': 'CANNED FRUITS AND SPECIALTIES',
  },
  {
    'Four Digit SIC Codes': 2034,
    'Four Digit SIC Code Descriptions': 'DEHYDRATED FRUITS, VEGETABLES, SOUPS',
  },
  {
    'Four Digit SIC Codes': 2035,
    'Four Digit SIC Code Descriptions': 'PICKLES, SAUCES, AND SALAD DRESSINGS',
  },
  {
    'Four Digit SIC Codes': 2037,
    'Four Digit SIC Code Descriptions': 'FROZEN FRUITS AND VEGETABLES',
  },
  {
    'Four Digit SIC Codes': 2038,
    'Four Digit SIC Code Descriptions': 'FROZEN SPECIALTIES, NEC',
  },
  {
    'Four Digit SIC Codes': 2041,
    'Four Digit SIC Code Descriptions': 'FLOUR AND OTHER GRAIN MILL PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2043,
    'Four Digit SIC Code Descriptions': 'CEREAL BREAKFAST FOODS',
  },
  {
    'Four Digit SIC Codes': 2044,
    'Four Digit SIC Code Descriptions': 'RICE MILLING',
  },
  {
    'Four Digit SIC Codes': 2045,
    'Four Digit SIC Code Descriptions': 'PREPARED FLOUR MIXES AND DOUGHS',
  },
  {
    'Four Digit SIC Codes': 2046,
    'Four Digit SIC Code Descriptions': 'WET CORN MILLING',
  },
  {
    'Four Digit SIC Codes': 2047,
    'Four Digit SIC Code Descriptions': 'DOG AND CAT FOOD',
  },
  {
    'Four Digit SIC Codes': 2048,
    'Four Digit SIC Code Descriptions': 'PREPARED FEEDS, NEC',
  },
  {
    'Four Digit SIC Codes': 2051,
    'Four Digit SIC Code Descriptions': 'BREAD, CAKE, AND RELATED PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2052,
    'Four Digit SIC Code Descriptions': 'COOKIES AND CRACKERS',
  },
  {
    'Four Digit SIC Codes': 2053,
    'Four Digit SIC Code Descriptions': 'FROZEN BAKERY PRODUCTS, EXCEPT BREAD',
  },
  {
    'Four Digit SIC Codes': 2061,
    'Four Digit SIC Code Descriptions': 'RAW CANE SUGAR',
  },
  {
    'Four Digit SIC Codes': 2062,
    'Four Digit SIC Code Descriptions': 'CANE SUGAR REFINING',
  },
  {
    'Four Digit SIC Codes': 2063,
    'Four Digit SIC Code Descriptions': 'BEET SUGAR',
  },
  {
    'Four Digit SIC Codes': 2064,
    'Four Digit SIC Code Descriptions': 'CANDY AND OTHER CONFECTIONERY PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2066,
    'Four Digit SIC Code Descriptions': 'CHOCOLATE AND COCOA PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2067,
    'Four Digit SIC Code Descriptions': 'CHEWING GUM',
  },
  {
    'Four Digit SIC Codes': 2068,
    'Four Digit SIC Code Descriptions': 'SALTED AND ROASTED NUTS AND SEEDS',
  },
  {
    'Four Digit SIC Codes': 2074,
    'Four Digit SIC Code Descriptions': 'COTTONSEED OIL MILLS',
  },
  {
    'Four Digit SIC Codes': 2075,
    'Four Digit SIC Code Descriptions': 'SOYBEAN OIL MILLS',
  },
  {
    'Four Digit SIC Codes': 2076,
    'Four Digit SIC Code Descriptions': 'VEGETABLE OIL MILLS, NEC',
  },
  {
    'Four Digit SIC Codes': 2077,
    'Four Digit SIC Code Descriptions': 'ANIMAL AND MARINE FATS AND OILS',
  },
  {
    'Four Digit SIC Codes': 2079,
    'Four Digit SIC Code Descriptions': 'EDIBLE FATS AND OILS',
  },
  {
    'Four Digit SIC Codes': 2082,
    'Four Digit SIC Code Descriptions': 'MALT BEVERAGES',
  },
  {
    'Four Digit SIC Codes': 2083,
    'Four Digit SIC Code Descriptions': 'MALT',
  },
  {
    'Four Digit SIC Codes': 2084,
    'Four Digit SIC Code Descriptions': 'WINES, BRANDY, AND BRANDY SPIRITS',
  },
  {
    'Four Digit SIC Codes': 2085,
    'Four Digit SIC Code Descriptions': 'DISTILLED AND BLENDED LIQUORS',
  },
  {
    'Four Digit SIC Codes': 2086,
    'Four Digit SIC Code Descriptions': 'BOTTLED AND CANNED SOFT DRINKS',
  },
  {
    'Four Digit SIC Codes': 2087,
    'Four Digit SIC Code Descriptions': 'FLAVORING EXTRACTS AND SYRUPS, NEC',
  },
  {
    'Four Digit SIC Codes': 2091,
    'Four Digit SIC Code Descriptions': 'CANNED AND CURED FISH AND SEAFOODS',
  },
  {
    'Four Digit SIC Codes': 2092,
    'Four Digit SIC Code Descriptions': 'FRESH OR FROZEN PACKAGED FISH',
  },
  {
    'Four Digit SIC Codes': 2095,
    'Four Digit SIC Code Descriptions': 'ROASTED COFFEE',
  },
  {
    'Four Digit SIC Codes': 2096,
    'Four Digit SIC Code Descriptions': 'POTATO CHIPS AND SIMILAR SNACKS',
  },
  {
    'Four Digit SIC Codes': 2097,
    'Four Digit SIC Code Descriptions': 'MANUFACTURED ICE',
  },
  {
    'Four Digit SIC Codes': 2098,
    'Four Digit SIC Code Descriptions': 'MACARONI AND SPAGHETTI',
  },
  {
    'Four Digit SIC Codes': 2099,
    'Four Digit SIC Code Descriptions': 'FOOD PREPARATIONS, NEC',
  },
  {
    'Four Digit SIC Codes': 2111,
    'Four Digit SIC Code Descriptions': 'CIGARETTES',
  },
  {
    'Four Digit SIC Codes': 2121,
    'Four Digit SIC Code Descriptions': 'CIGARS',
  },
  {
    'Four Digit SIC Codes': 2131,
    'Four Digit SIC Code Descriptions': 'CHEWING AND SMOKING TOBACCO',
  },
  {
    'Four Digit SIC Codes': 2141,
    'Four Digit SIC Code Descriptions': 'TOBACCO STEMMING AND REDRYING',
  },
  {
    'Four Digit SIC Codes': 2211,
    'Four Digit SIC Code Descriptions': 'BROADWOVEN FABRIC MILLS, COTTON',
  },
  {
    'Four Digit SIC Codes': 2221,
    'Four Digit SIC Code Descriptions': 'BROADWOVEN FABRIC MILLS, MANMADE',
  },
  {
    'Four Digit SIC Codes': 2231,
    'Four Digit SIC Code Descriptions': 'BROADWOVEN FABRIC MILLS, WOOL',
  },
  {
    'Four Digit SIC Codes': 2241,
    'Four Digit SIC Code Descriptions': 'NARROW FABRIC MILLS',
  },
  {
    'Four Digit SIC Codes': 2251,
    'Four Digit SIC Code Descriptions': "WOMEN'S HOSIERY, EXCEPT SOCKS",
  },
  {
    'Four Digit SIC Codes': 2252,
    'Four Digit SIC Code Descriptions': 'HOSIERY, NEC',
  },
  {
    'Four Digit SIC Codes': 2253,
    'Four Digit SIC Code Descriptions': 'KNIT OUTERWEAR MILLS',
  },
  {
    'Four Digit SIC Codes': 2254,
    'Four Digit SIC Code Descriptions': 'KNIT UNDERWEAR MILLS',
  },
  {
    'Four Digit SIC Codes': 2257,
    'Four Digit SIC Code Descriptions': 'WEFT KNIT FABRIC MILLS',
  },
  {
    'Four Digit SIC Codes': 2258,
    'Four Digit SIC Code Descriptions': 'LACE AND WARP KNIT FABRIC MILLS',
  },
  {
    'Four Digit SIC Codes': 2259,
    'Four Digit SIC Code Descriptions': 'KNITTING MILLS, NEC',
  },
  {
    'Four Digit SIC Codes': 2261,
    'Four Digit SIC Code Descriptions': 'FINISHING PLANTS, COTTON',
  },
  {
    'Four Digit SIC Codes': 2262,
    'Four Digit SIC Code Descriptions': 'FINISHING PLANTS, MANMADE',
  },
  {
    'Four Digit SIC Codes': 2269,
    'Four Digit SIC Code Descriptions': 'FINISHING PLANTS, NEC',
  },
  {
    'Four Digit SIC Codes': 2273,
    'Four Digit SIC Code Descriptions': 'CARPETS AND RUGS',
  },
  {
    'Four Digit SIC Codes': 2281,
    'Four Digit SIC Code Descriptions': 'YARN SPINNING MILLS',
  },
  {
    'Four Digit SIC Codes': 2282,
    'Four Digit SIC Code Descriptions': 'THROWING AND WINDING MILLS',
  },
  {
    'Four Digit SIC Codes': 2284,
    'Four Digit SIC Code Descriptions': 'THREAD MILLS',
  },
  {
    'Four Digit SIC Codes': 2295,
    'Four Digit SIC Code Descriptions': 'COATED FABRICS, NOT RUBBERIZED',
  },
  {
    'Four Digit SIC Codes': 2296,
    'Four Digit SIC Code Descriptions': 'TIRE CORD AND FABRICS',
  },
  {
    'Four Digit SIC Codes': 2297,
    'Four Digit SIC Code Descriptions': 'NONWOVEN FABRICS',
  },
  {
    'Four Digit SIC Codes': 2298,
    'Four Digit SIC Code Descriptions': 'CORDAGE AND TWINE',
  },
  {
    'Four Digit SIC Codes': 2299,
    'Four Digit SIC Code Descriptions': 'TEXTILE GOODS, NEC',
  },
  {
    'Four Digit SIC Codes': 2311,
    'Four Digit SIC Code Descriptions': "MEN'S AND BOY'S SUITS AND COATS",
  },
  {
    'Four Digit SIC Codes': 2321,
    'Four Digit SIC Code Descriptions': "MEN'S AND BOY'S FURNISHINGS",
  },
  {
    'Four Digit SIC Codes': 2322,
    'Four Digit SIC Code Descriptions': "MEN'S AND BOY'S UNDERWEAR AND NIGHTWEAR",
  },
  {
    'Four Digit SIC Codes': 2323,
    'Four Digit SIC Code Descriptions': "MEN'S AND BOY'S NECKWEAR",
  },
  {
    'Four Digit SIC Codes': 2325,
    'Four Digit SIC Code Descriptions': "MEN'S AND BOY'S TROUSERS AND SLACKS",
  },
  {
    'Four Digit SIC Codes': 2326,
    'Four Digit SIC Code Descriptions': "MEN'S AND BOY'S WORK CLOTHING",
  },
  {
    'Four Digit SIC Codes': 2329,
    'Four Digit SIC Code Descriptions': "MEN'S AND BOY'S CLOTHING, NEC",
  },
  {
    'Four Digit SIC Codes': 2331,
    'Four Digit SIC Code Descriptions': "WOMEN'S AND MISSES' BLOUSES AND SHIRTS",
  },
  {
    'Four Digit SIC Codes': 2335,
    'Four Digit SIC Code Descriptions': "WOMEN'S, JUNIOR'S, AND MISSES' DRESSES",
  },
  {
    'Four Digit SIC Codes': 2337,
    'Four Digit SIC Code Descriptions': "WOMEN'S AND MISSES' SUITS AND COATS",
  },
  {
    'Four Digit SIC Codes': 2339,
    'Four Digit SIC Code Descriptions': "WOMEN'S AND MISSES' OUTERWEAR, NEC",
  },
  {
    'Four Digit SIC Codes': 2341,
    'Four Digit SIC Code Descriptions': "WOMEN'S AND CHILDREN'S UNDERWEAR",
  },
  {
    'Four Digit SIC Codes': 2342,
    'Four Digit SIC Code Descriptions': 'BRAS, GIRDLES, AND ALLIED GARMENTS',
  },
  {
    'Four Digit SIC Codes': 2353,
    'Four Digit SIC Code Descriptions': 'HATS, CAPS, AND MILLINERY',
  },
  {
    'Four Digit SIC Codes': 2361,
    'Four Digit SIC Code Descriptions': "GIRL'S AND CHILDREN'S DRESSES, BLOUSES",
  },
  {
    'Four Digit SIC Codes': 2369,
    'Four Digit SIC Code Descriptions': "GIRL'S AND CHILDREN'S OUTERWEAR, NEC",
  },
  {
    'Four Digit SIC Codes': 2371,
    'Four Digit SIC Code Descriptions': 'FUR GOODS',
  },
  {
    'Four Digit SIC Codes': 2381,
    'Four Digit SIC Code Descriptions': 'FABRIC DRESS AND WORK GLOVES',
  },
  {
    'Four Digit SIC Codes': 2384,
    'Four Digit SIC Code Descriptions': 'ROBES AND DRESSING GOWNS',
  },
  {
    'Four Digit SIC Codes': 2385,
    'Four Digit SIC Code Descriptions': 'WATERPROOF OUTERWEAR',
  },
  {
    'Four Digit SIC Codes': 2386,
    'Four Digit SIC Code Descriptions': 'LEATHER AND SHEEP-LINED CLOTHING',
  },
  {
    'Four Digit SIC Codes': 2387,
    'Four Digit SIC Code Descriptions': 'APPAREL BELTS',
  },
  {
    'Four Digit SIC Codes': 2389,
    'Four Digit SIC Code Descriptions': 'APPAREL AND ACCESSORIES, NEC',
  },
  {
    'Four Digit SIC Codes': 2391,
    'Four Digit SIC Code Descriptions': 'CURTAINS AND DRAPERIES',
  },
  {
    'Four Digit SIC Codes': 2392,
    'Four Digit SIC Code Descriptions': 'HOUSEHOLD FURNISHINGS, NEC',
  },
  {
    'Four Digit SIC Codes': 2393,
    'Four Digit SIC Code Descriptions': 'TEXTILE BAGS',
  },
  {
    'Four Digit SIC Codes': 2394,
    'Four Digit SIC Code Descriptions': 'CANVAS AND RELATED PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2395,
    'Four Digit SIC Code Descriptions': 'PLEATING AND STITCHING',
  },
  {
    'Four Digit SIC Codes': 2396,
    'Four Digit SIC Code Descriptions': 'AUTOMOTIVE AND APPAREL TRIMMINGS',
  },
  {
    'Four Digit SIC Codes': 2397,
    'Four Digit SIC Code Descriptions': 'SCHIFFLI MACHINE EMBROIDERIES',
  },
  {
    'Four Digit SIC Codes': 2399,
    'Four Digit SIC Code Descriptions': 'FABRICATED TEXTILE PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 2411,
    'Four Digit SIC Code Descriptions': 'LOGGING',
  },
  {
    'Four Digit SIC Codes': 2421,
    'Four Digit SIC Code Descriptions': 'SAWMILLS AND PLANING MILLS, GENERAL',
  },
  {
    'Four Digit SIC Codes': 2426,
    'Four Digit SIC Code Descriptions': 'HARDWOOD DIMENSION AND FLOORING MILLS',
  },
  {
    'Four Digit SIC Codes': 2429,
    'Four Digit SIC Code Descriptions': 'SPECIAL PRODUCT SAWMILLS, NEC',
  },
  {
    'Four Digit SIC Codes': 2431,
    'Four Digit SIC Code Descriptions': 'MILLWORK',
  },
  {
    'Four Digit SIC Codes': 2434,
    'Four Digit SIC Code Descriptions': 'WOOD KITCHEN CABINETS',
  },
  {
    'Four Digit SIC Codes': 2435,
    'Four Digit SIC Code Descriptions': 'HARDWOOD VENEER AND PLYWOOD',
  },
  {
    'Four Digit SIC Codes': 2436,
    'Four Digit SIC Code Descriptions': 'SOFTWOOD VENEER AND PLYWOOD',
  },
  {
    'Four Digit SIC Codes': 2439,
    'Four Digit SIC Code Descriptions': 'STRUCTURAL WOOD MEMBERS, NEC',
  },
  {
    'Four Digit SIC Codes': 2441,
    'Four Digit SIC Code Descriptions': 'NAILED WOOD BOXES AND SHOOK',
  },
  {
    'Four Digit SIC Codes': 2448,
    'Four Digit SIC Code Descriptions': 'WOOD PALLETS AND SKIDS',
  },
  {
    'Four Digit SIC Codes': 2449,
    'Four Digit SIC Code Descriptions': 'WOOD CONTAINERS, NEC',
  },
  {
    'Four Digit SIC Codes': 2451,
    'Four Digit SIC Code Descriptions': 'MOBILE HOMES',
  },
  {
    'Four Digit SIC Codes': 2452,
    'Four Digit SIC Code Descriptions': 'PREFABRICATED WOOD BUILDINGS',
  },
  {
    'Four Digit SIC Codes': 2491,
    'Four Digit SIC Code Descriptions': 'WOOD PRESERVING',
  },
  {
    'Four Digit SIC Codes': 2493,
    'Four Digit SIC Code Descriptions': 'RECONSTITUTED WOOD PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2499,
    'Four Digit SIC Code Descriptions': 'WOOD PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 2511,
    'Four Digit SIC Code Descriptions': 'WOOD HOUSEHOLD FURNITURE',
  },
  {
    'Four Digit SIC Codes': 2512,
    'Four Digit SIC Code Descriptions': 'UPHOLSTERED HOUSEHOLD FURNITURE',
  },
  {
    'Four Digit SIC Codes': 2514,
    'Four Digit SIC Code Descriptions': 'METAL HOUSEHOLD FURNITURE',
  },
  {
    'Four Digit SIC Codes': 2515,
    'Four Digit SIC Code Descriptions': 'MATTRESSES AND BEDSPRINGS',
  },
  {
    'Four Digit SIC Codes': 2517,
    'Four Digit SIC Code Descriptions': 'WOOD TELEVISION AND RADIO CABINETS',
  },
  {
    'Four Digit SIC Codes': 2519,
    'Four Digit SIC Code Descriptions': 'HOUSEHOLD FURNITURE, NEC',
  },
  {
    'Four Digit SIC Codes': 2521,
    'Four Digit SIC Code Descriptions': 'WOOD OFFICE FURNITURE',
  },
  {
    'Four Digit SIC Codes': 2522,
    'Four Digit SIC Code Descriptions': 'OFFICE FURNITURE, EXCEPT WOOD',
  },
  {
    'Four Digit SIC Codes': 2531,
    'Four Digit SIC Code Descriptions': 'PUBLIC BUILDING AND RELATED FURNITURE',
  },
  {
    'Four Digit SIC Codes': 2541,
    'Four Digit SIC Code Descriptions': 'WOOD PARTITIONS AND FIXTURES',
  },
  {
    'Four Digit SIC Codes': 2542,
    'Four Digit SIC Code Descriptions': 'PARTITIONS AND FIXTURES, EXCEPT WOOD',
  },
  {
    'Four Digit SIC Codes': 2591,
    'Four Digit SIC Code Descriptions': 'DRAPERY HARDWARE AND BLINDS AND SHADES',
  },
  {
    'Four Digit SIC Codes': 2599,
    'Four Digit SIC Code Descriptions': 'FURNITURE AND FIXTURES, NEC',
  },
  {
    'Four Digit SIC Codes': 2611,
    'Four Digit SIC Code Descriptions': 'PULP MILLS',
  },
  {
    'Four Digit SIC Codes': 2621,
    'Four Digit SIC Code Descriptions': 'PAPER MILLS',
  },
  {
    'Four Digit SIC Codes': 2631,
    'Four Digit SIC Code Descriptions': 'PAPERBOARD MILLS',
  },
  {
    'Four Digit SIC Codes': 2652,
    'Four Digit SIC Code Descriptions': 'SETUP PAPERBOARD BOXES',
  },
  {
    'Four Digit SIC Codes': 2653,
    'Four Digit SIC Code Descriptions': 'CORRUGATED AND SOLID FIBER BOXES',
  },
  {
    'Four Digit SIC Codes': 2655,
    'Four Digit SIC Code Descriptions': 'FIBER CANS, DRUMS, AND SIMILAR PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2656,
    'Four Digit SIC Code Descriptions': 'SANITARY FOOD CONTAINERS',
  },
  {
    'Four Digit SIC Codes': 2657,
    'Four Digit SIC Code Descriptions': 'FOLDING PAPERBOARD BOXES',
  },
  {
    'Four Digit SIC Codes': 2671,
    'Four Digit SIC Code Descriptions': 'PAPER; COATED AND LAMINATED PACKAGING',
  },
  {
    'Four Digit SIC Codes': 2672,
    'Four Digit SIC Code Descriptions': 'PAPER; COATED AND LAMINATED, NEC',
  },
  {
    'Four Digit SIC Codes': 2673,
    'Four Digit SIC Code Descriptions': 'BAGS: PLASTIC, LAMINATED, AND COATED',
  },
  {
    'Four Digit SIC Codes': 2674,
    'Four Digit SIC Code Descriptions': 'BAGS: UNCOATED PAPER AND MULTIWALL',
  },
  {
    'Four Digit SIC Codes': 2675,
    'Four Digit SIC Code Descriptions': 'DIE-CUT PAPER AND BOARD',
  },
  {
    'Four Digit SIC Codes': 2676,
    'Four Digit SIC Code Descriptions': 'SANITARY PAPER PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2677,
    'Four Digit SIC Code Descriptions': 'ENVELOPES',
  },
  {
    'Four Digit SIC Codes': 2678,
    'Four Digit SIC Code Descriptions': 'STATIONERY PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2679,
    'Four Digit SIC Code Descriptions': 'CONVERTED PAPER PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 2711,
    'Four Digit SIC Code Descriptions': 'NEWSPAPERS',
  },
  {
    'Four Digit SIC Codes': 2721,
    'Four Digit SIC Code Descriptions': 'PERIODICALS',
  },
  {
    'Four Digit SIC Codes': 2731,
    'Four Digit SIC Code Descriptions': 'BOOK PUBLISHING',
  },
  {
    'Four Digit SIC Codes': 2732,
    'Four Digit SIC Code Descriptions': 'BOOK PRINTING',
  },
  {
    'Four Digit SIC Codes': 2741,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS PUBLISHING',
  },
  {
    'Four Digit SIC Codes': 2752,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL PRINTING, LITHOGRAPHIC',
  },
  {
    'Four Digit SIC Codes': 2754,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL PRINTING, GRAVURE',
  },
  {
    'Four Digit SIC Codes': 2759,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL PRINTING, NEC',
  },
  {
    'Four Digit SIC Codes': 2761,
    'Four Digit SIC Code Descriptions': 'MANIFOLD BUSINESS FORMS',
  },
  {
    'Four Digit SIC Codes': 2771,
    'Four Digit SIC Code Descriptions': 'GREETING CARDS',
  },
  {
    'Four Digit SIC Codes': 2782,
    'Four Digit SIC Code Descriptions': 'BLANKBOOKS AND LOOSELEAF BINDERS',
  },
  {
    'Four Digit SIC Codes': 2789,
    'Four Digit SIC Code Descriptions': 'BOOKBINDING AND RELATED WORK',
  },
  {
    'Four Digit SIC Codes': 2791,
    'Four Digit SIC Code Descriptions': 'TYPESETTING',
  },
  {
    'Four Digit SIC Codes': 2796,
    'Four Digit SIC Code Descriptions': 'PLATEMAKING SERVICES',
  },
  {
    'Four Digit SIC Codes': 2812,
    'Four Digit SIC Code Descriptions': 'ALKALIES AND CHLORINE',
  },
  {
    'Four Digit SIC Codes': 2813,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL GASES',
  },
  {
    'Four Digit SIC Codes': 2816,
    'Four Digit SIC Code Descriptions': 'INORGANIC PIGMENTS',
  },
  {
    'Four Digit SIC Codes': 2819,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL INORGANIC CHEMICALS, NEC',
  },
  {
    'Four Digit SIC Codes': 2821,
    'Four Digit SIC Code Descriptions': 'PLASTICS MATERIALS AND RESINS',
  },
  {
    'Four Digit SIC Codes': 2822,
    'Four Digit SIC Code Descriptions': 'SYNTHETIC RUBBER',
  },
  {
    'Four Digit SIC Codes': 2823,
    'Four Digit SIC Code Descriptions': 'CELLULOSIC MANMADE FIBERS',
  },
  {
    'Four Digit SIC Codes': 2824,
    'Four Digit SIC Code Descriptions': 'ORGANIC FIBERS, NONCELLULOSIC',
  },
  {
    'Four Digit SIC Codes': 2833,
    'Four Digit SIC Code Descriptions': 'MEDICINALS AND BOTANICALS',
  },
  {
    'Four Digit SIC Codes': 2834,
    'Four Digit SIC Code Descriptions': 'PHARMACEUTICAL PREPARATIONS',
  },
  {
    'Four Digit SIC Codes': 2835,
    'Four Digit SIC Code Descriptions': 'DIAGNOSTIC SUBSTANCES',
  },
  {
    'Four Digit SIC Codes': 2836,
    'Four Digit SIC Code Descriptions': 'BIOLOGICAL PRODUCTS, EXCEPT DIAGNOSTIC',
  },
  {
    'Four Digit SIC Codes': 2841,
    'Four Digit SIC Code Descriptions': 'SOAP AND OTHER DETERGENTS',
  },
  {
    'Four Digit SIC Codes': 2842,
    'Four Digit SIC Code Descriptions': 'POLISHES AND SANITATION GOODS',
  },
  {
    'Four Digit SIC Codes': 2843,
    'Four Digit SIC Code Descriptions': 'SURFACE ACTIVE AGENTS',
  },
  {
    'Four Digit SIC Codes': 2844,
    'Four Digit SIC Code Descriptions': 'TOILET PREPARATIONS',
  },
  {
    'Four Digit SIC Codes': 2851,
    'Four Digit SIC Code Descriptions': 'PAINTS AND ALLIED PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 2861,
    'Four Digit SIC Code Descriptions': 'GUM AND WOOD CHEMICALS',
  },
  {
    'Four Digit SIC Codes': 2865,
    'Four Digit SIC Code Descriptions': 'CYCLIC CRUDES AND INTERMEDIATES',
  },
  {
    'Four Digit SIC Codes': 2869,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL ORGANIC CHEMICALS, NEC',
  },
  {
    'Four Digit SIC Codes': 2873,
    'Four Digit SIC Code Descriptions': 'NITROGENOUS FERTILIZERS',
  },
  {
    'Four Digit SIC Codes': 2874,
    'Four Digit SIC Code Descriptions': 'PHOSPHATIC FERTILIZERS',
  },
  {
    'Four Digit SIC Codes': 2875,
    'Four Digit SIC Code Descriptions': 'FERTILIZERS, MIXING ONLY',
  },
  {
    'Four Digit SIC Codes': 2879,
    'Four Digit SIC Code Descriptions': 'AGRICULTURAL CHEMICALS, NEC',
  },
  {
    'Four Digit SIC Codes': 2891,
    'Four Digit SIC Code Descriptions': 'ADHESIVES AND SEALANTS',
  },
  {
    'Four Digit SIC Codes': 2892,
    'Four Digit SIC Code Descriptions': 'EXPLOSIVES',
  },
  {
    'Four Digit SIC Codes': 2893,
    'Four Digit SIC Code Descriptions': 'PRINTING INK',
  },
  {
    'Four Digit SIC Codes': 2895,
    'Four Digit SIC Code Descriptions': 'CARBON BLACK',
  },
  {
    'Four Digit SIC Codes': 2899,
    'Four Digit SIC Code Descriptions': 'CHEMICAL PREPARATIONS, NEC',
  },
  {
    'Four Digit SIC Codes': 2911,
    'Four Digit SIC Code Descriptions': 'PETROLEUM REFINING',
  },
  {
    'Four Digit SIC Codes': 2951,
    'Four Digit SIC Code Descriptions': 'ASPHALT PAVING MIXTURES AND BLOCKS',
  },
  {
    'Four Digit SIC Codes': 2952,
    'Four Digit SIC Code Descriptions': 'ASPHALT FELTS AND COATINGS',
  },
  {
    'Four Digit SIC Codes': 2992,
    'Four Digit SIC Code Descriptions': 'LUBRICATING OILS AND GREASES',
  },
  {
    'Four Digit SIC Codes': 2999,
    'Four Digit SIC Code Descriptions': 'PETROLEUM AND COAL PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 3011,
    'Four Digit SIC Code Descriptions': 'TIRES AND INNER TUBES',
  },
  {
    'Four Digit SIC Codes': 3021,
    'Four Digit SIC Code Descriptions': 'RUBBER AND PLASTICS FOOTWEAR',
  },
  {
    'Four Digit SIC Codes': 3052,
    'Four Digit SIC Code Descriptions': 'RUBBER AND PLASTICS HOSE AND BELTINGS',
  },
  {
    'Four Digit SIC Codes': 3053,
    'Four Digit SIC Code Descriptions': 'GASKETS; PACKING AND SEALING DEVICES',
  },
  {
    'Four Digit SIC Codes': 3061,
    'Four Digit SIC Code Descriptions': 'MECHANICAL RUBBER GOODS',
  },
  {
    'Four Digit SIC Codes': 3069,
    'Four Digit SIC Code Descriptions': 'FABRICATED RUBBER PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 3081,
    'Four Digit SIC Code Descriptions': 'UNSUPPORTED PLASTICS FILM AND SHEET',
  },
  {
    'Four Digit SIC Codes': 3082,
    'Four Digit SIC Code Descriptions': 'UNSUPPORTED PLASTICS PROFILE SHAPES',
  },
  {
    'Four Digit SIC Codes': 3083,
    'Four Digit SIC Code Descriptions': 'LAMINATED PLASTICS PLATE AND SHEET',
  },
  {
    'Four Digit SIC Codes': 3084,
    'Four Digit SIC Code Descriptions': 'PLASTICS PIPE',
  },
  {
    'Four Digit SIC Codes': 3085,
    'Four Digit SIC Code Descriptions': 'PLASTICS BOTTLES',
  },
  {
    'Four Digit SIC Codes': 3086,
    'Four Digit SIC Code Descriptions': 'PLASTICS FOAM PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3087,
    'Four Digit SIC Code Descriptions': 'CUSTOM COMPOUND PURCHASED RESINS',
  },
  {
    'Four Digit SIC Codes': 3088,
    'Four Digit SIC Code Descriptions': 'PLASTICS PLUMBING FIXTURES',
  },
  {
    'Four Digit SIC Codes': 3089,
    'Four Digit SIC Code Descriptions': 'PLASTICS PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 3111,
    'Four Digit SIC Code Descriptions': 'LEATHER TANNING AND FINISHING',
  },
  {
    'Four Digit SIC Codes': 3131,
    'Four Digit SIC Code Descriptions': 'FOOTWEAR CUT STOCK',
  },
  {
    'Four Digit SIC Codes': 3142,
    'Four Digit SIC Code Descriptions': 'HOUSE SLIPPERS',
  },
  {
    'Four Digit SIC Codes': 3143,
    'Four Digit SIC Code Descriptions': "MEN'S FOOTWEAR, EXCEPT ATHLETIC",
  },
  {
    'Four Digit SIC Codes': 3144,
    'Four Digit SIC Code Descriptions': "WOMEN'S FOOTWEAR, EXCEPT ATHLETIC",
  },
  {
    'Four Digit SIC Codes': 3149,
    'Four Digit SIC Code Descriptions': 'FOOTWEAR, EXCEPT RUBBER, NEC',
  },
  {
    'Four Digit SIC Codes': 3151,
    'Four Digit SIC Code Descriptions': 'LEATHER GLOVES AND MITTENS',
  },
  {
    'Four Digit SIC Codes': 3161,
    'Four Digit SIC Code Descriptions': 'LUGGAGE',
  },
  {
    'Four Digit SIC Codes': 3171,
    'Four Digit SIC Code Descriptions': "WOMEN'S HANDBAGS AND PURSES",
  },
  {
    'Four Digit SIC Codes': 3172,
    'Four Digit SIC Code Descriptions': 'PERSONAL LEATHER GOODS, NEC',
  },
  {
    'Four Digit SIC Codes': 3199,
    'Four Digit SIC Code Descriptions': 'LEATHER GOODS, NEC',
  },
  {
    'Four Digit SIC Codes': 3211,
    'Four Digit SIC Code Descriptions': 'FLAT GLASS',
  },
  {
    'Four Digit SIC Codes': 3221,
    'Four Digit SIC Code Descriptions': 'GLASS CONTAINERS',
  },
  {
    'Four Digit SIC Codes': 3229,
    'Four Digit SIC Code Descriptions': 'PRESSED AND BLOWN GLASS, NEC',
  },
  {
    'Four Digit SIC Codes': 3231,
    'Four Digit SIC Code Descriptions': 'PRODUCTS OF PURCHASED GLASS',
  },
  {
    'Four Digit SIC Codes': 3241,
    'Four Digit SIC Code Descriptions': 'CEMENT, HYDRAULIC',
  },
  {
    'Four Digit SIC Codes': 3251,
    'Four Digit SIC Code Descriptions': 'BRICK AND STRUCTURAL CLAY TILE',
  },
  {
    'Four Digit SIC Codes': 3253,
    'Four Digit SIC Code Descriptions': 'CERAMIC WALL AND FLOOR TILE',
  },
  {
    'Four Digit SIC Codes': 3255,
    'Four Digit SIC Code Descriptions': 'CLAY REFRACTORIES',
  },
  {
    'Four Digit SIC Codes': 3259,
    'Four Digit SIC Code Descriptions': 'STRUCTURAL CLAY PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 3261,
    'Four Digit SIC Code Descriptions': 'VITREOUS PLUMBING FIXTURES',
  },
  {
    'Four Digit SIC Codes': 3262,
    'Four Digit SIC Code Descriptions': 'VITREOUS CHINA TABLE AND KITCHENWARE',
  },
  {
    'Four Digit SIC Codes': 3263,
    'Four Digit SIC Code Descriptions': 'SEMIVITREOUS TABLE AND KITCHENWARE',
  },
  {
    'Four Digit SIC Codes': 3264,
    'Four Digit SIC Code Descriptions': 'PORCELAIN ELECTRICAL SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 3269,
    'Four Digit SIC Code Descriptions': 'POTTERY PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 3271,
    'Four Digit SIC Code Descriptions': 'CONCRETE BLOCK AND BRICK',
  },
  {
    'Four Digit SIC Codes': 3272,
    'Four Digit SIC Code Descriptions': 'CONCRETE PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 3273,
    'Four Digit SIC Code Descriptions': 'READY-MIXED CONCRETE',
  },
  {
    'Four Digit SIC Codes': 3274,
    'Four Digit SIC Code Descriptions': 'LIME',
  },
  {
    'Four Digit SIC Codes': 3275,
    'Four Digit SIC Code Descriptions': 'GYPSUM PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3281,
    'Four Digit SIC Code Descriptions': 'CUT STONE AND STONE PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3291,
    'Four Digit SIC Code Descriptions': 'ABRASIVE PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3292,
    'Four Digit SIC Code Descriptions': 'ASBESTOS PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3295,
    'Four Digit SIC Code Descriptions': 'MINERALS, GROUND OR TREATED',
  },
  {
    'Four Digit SIC Codes': 3296,
    'Four Digit SIC Code Descriptions': 'MINERAL WOOL',
  },
  {
    'Four Digit SIC Codes': 3297,
    'Four Digit SIC Code Descriptions': 'NONCLAY REFRACTORIES',
  },
  {
    'Four Digit SIC Codes': 3299,
    'Four Digit SIC Code Descriptions': 'NONMETALLIC MINERAL PRODUCTS,',
  },
  {
    'Four Digit SIC Codes': 3312,
    'Four Digit SIC Code Descriptions': 'BLAST FURNACES AND STEEL MILLS',
  },
  {
    'Four Digit SIC Codes': 3313,
    'Four Digit SIC Code Descriptions': 'ELECTROMETALLURGICAL PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3315,
    'Four Digit SIC Code Descriptions': 'STEEL WIRE AND RELATED PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3316,
    'Four Digit SIC Code Descriptions': 'COLD FINISHING OF STEEL SHAPES',
  },
  {
    'Four Digit SIC Codes': 3317,
    'Four Digit SIC Code Descriptions': 'STEEL PIPE AND TUBES',
  },
  {
    'Four Digit SIC Codes': 3321,
    'Four Digit SIC Code Descriptions': 'GRAY AND DUCTILE IRON FOUNDRIES',
  },
  {
    'Four Digit SIC Codes': 3322,
    'Four Digit SIC Code Descriptions': 'MALLEABLE IRON FOUNDRIES',
  },
  {
    'Four Digit SIC Codes': 3324,
    'Four Digit SIC Code Descriptions': 'STEEL INVESTMENT FOUNDRIES',
  },
  {
    'Four Digit SIC Codes': 3325,
    'Four Digit SIC Code Descriptions': 'STEEL FOUNDRIES, NEC',
  },
  {
    'Four Digit SIC Codes': 3331,
    'Four Digit SIC Code Descriptions': 'PRIMARY COPPER',
  },
  {
    'Four Digit SIC Codes': 3334,
    'Four Digit SIC Code Descriptions': 'PRIMARY ALUMINUM',
  },
  {
    'Four Digit SIC Codes': 3339,
    'Four Digit SIC Code Descriptions': 'PRIMARY NONFERROUS METALS, NEC',
  },
  {
    'Four Digit SIC Codes': 3341,
    'Four Digit SIC Code Descriptions': 'SECONDARY NONFERROUS METALS',
  },
  {
    'Four Digit SIC Codes': 3351,
    'Four Digit SIC Code Descriptions': 'COPPER ROLLING AND DRAWING',
  },
  {
    'Four Digit SIC Codes': 3353,
    'Four Digit SIC Code Descriptions': 'ALUMINUM SHEET, PLATE, AND FOIL',
  },
  {
    'Four Digit SIC Codes': 3354,
    'Four Digit SIC Code Descriptions': 'ALUMINUM EXTRUDED PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3355,
    'Four Digit SIC Code Descriptions': 'ALUMINUM ROLLING AND DRAWING, NEC',
  },
  {
    'Four Digit SIC Codes': 3356,
    'Four Digit SIC Code Descriptions': 'NONFERROUS ROLLING AND DRAWING, NEC',
  },
  {
    'Four Digit SIC Codes': 3357,
    'Four Digit SIC Code Descriptions': 'NONFERROUS WIREDRAWING AND INSULATING',
  },
  {
    'Four Digit SIC Codes': 3363,
    'Four Digit SIC Code Descriptions': 'ALUMINUM DIE-CASTINGS',
  },
  {
    'Four Digit SIC Codes': 3364,
    'Four Digit SIC Code Descriptions': 'NONFERROUS DIE-CASTINGS EXCEPT ALUMINUM',
  },
  {
    'Four Digit SIC Codes': 3365,
    'Four Digit SIC Code Descriptions': 'ALUMINUM FOUNDRIES',
  },
  {
    'Four Digit SIC Codes': 3366,
    'Four Digit SIC Code Descriptions': 'COPPER FOUNDRIES',
  },
  {
    'Four Digit SIC Codes': 3369,
    'Four Digit SIC Code Descriptions': 'NONFERROUS FOUNDRIES, NEC',
  },
  {
    'Four Digit SIC Codes': 3398,
    'Four Digit SIC Code Descriptions': 'METAL HEAT TREATING',
  },
  {
    'Four Digit SIC Codes': 3399,
    'Four Digit SIC Code Descriptions': 'PRIMARY METAL PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3411,
    'Four Digit SIC Code Descriptions': 'METAL CANS',
  },
  {
    'Four Digit SIC Codes': 3412,
    'Four Digit SIC Code Descriptions': 'METAL BARRELS, DRUMS, AND PAILS',
  },
  {
    'Four Digit SIC Codes': 3421,
    'Four Digit SIC Code Descriptions': 'CUTLERY',
  },
  {
    'Four Digit SIC Codes': 3423,
    'Four Digit SIC Code Descriptions': 'HAND AND EDGE TOOLS, NEC',
  },
  {
    'Four Digit SIC Codes': 3425,
    'Four Digit SIC Code Descriptions': 'SAW BLADES AND HANDSAWS',
  },
  {
    'Four Digit SIC Codes': 3429,
    'Four Digit SIC Code Descriptions': 'HARDWARE, NEC',
  },
  {
    'Four Digit SIC Codes': 3431,
    'Four Digit SIC Code Descriptions': 'METAL SANITARY WARE',
  },
  {
    'Four Digit SIC Codes': 3432,
    'Four Digit SIC Code Descriptions': 'PLUMBING FIXTURE FITTINGS AND TRIM',
  },
  {
    'Four Digit SIC Codes': 3433,
    'Four Digit SIC Code Descriptions': 'HEATING EQUIPMENT, EXCEPT ELECTRIC',
  },
  {
    'Four Digit SIC Codes': 3441,
    'Four Digit SIC Code Descriptions': 'FABRICATED STRUCTURAL METAL',
  },
  {
    'Four Digit SIC Codes': 3442,
    'Four Digit SIC Code Descriptions': 'METAL DOORS, SASH, AND TRIM',
  },
  {
    'Four Digit SIC Codes': 3443,
    'Four Digit SIC Code Descriptions': 'FABRICATED PLATE WORK (BOILER SHOP)',
  },
  {
    'Four Digit SIC Codes': 3444,
    'Four Digit SIC Code Descriptions': 'SHEET METALWORK',
  },
  {
    'Four Digit SIC Codes': 3446,
    'Four Digit SIC Code Descriptions': 'ARCHITECTURAL METALWORK',
  },
  {
    'Four Digit SIC Codes': 3448,
    'Four Digit SIC Code Descriptions': 'PREFABRICATED METAL BUILDINGS',
  },
  {
    'Four Digit SIC Codes': 3449,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS METALWORK',
  },
  {
    'Four Digit SIC Codes': 3451,
    'Four Digit SIC Code Descriptions': 'SCREW MACHINE PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3452,
    'Four Digit SIC Code Descriptions': 'BOLTS, NUTS, RIVETS, AND WASHERS',
  },
  {
    'Four Digit SIC Codes': 3462,
    'Four Digit SIC Code Descriptions': 'IRON AND STEEL FORGINGS',
  },
  {
    'Four Digit SIC Codes': 3463,
    'Four Digit SIC Code Descriptions': 'NONFERROUS FORGINGS',
  },
  {
    'Four Digit SIC Codes': 3465,
    'Four Digit SIC Code Descriptions': 'AUTOMOTIVE STAMPINGS',
  },
  {
    'Four Digit SIC Codes': 3466,
    'Four Digit SIC Code Descriptions': 'CROWNS AND CLOSURES',
  },
  {
    'Four Digit SIC Codes': 3469,
    'Four Digit SIC Code Descriptions': 'METAL STAMPINGS, NEC',
  },
  {
    'Four Digit SIC Codes': 3471,
    'Four Digit SIC Code Descriptions': 'PLATING AND POLISHING',
  },
  {
    'Four Digit SIC Codes': 3479,
    'Four Digit SIC Code Descriptions': 'METAL COATING AND ALLIED SERVICES',
  },
  {
    'Four Digit SIC Codes': 3482,
    'Four Digit SIC Code Descriptions': 'SMALL ARMS AMMUNITION',
  },
  {
    'Four Digit SIC Codes': 3483,
    'Four Digit SIC Code Descriptions': 'AMMUNITION, EXCEPT FOR SMALL ARMS, NEC',
  },
  {
    'Four Digit SIC Codes': 3484,
    'Four Digit SIC Code Descriptions': 'SMALL ARMS',
  },
  {
    'Four Digit SIC Codes': 3489,
    'Four Digit SIC Code Descriptions': 'ORDNANCE AND ACCESSORIES, NEC',
  },
  {
    'Four Digit SIC Codes': 3491,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL VALVES',
  },
  {
    'Four Digit SIC Codes': 3492,
    'Four Digit SIC Code Descriptions': 'FLUID POWER VALVES AND HOSE FITTINGS',
  },
  {
    'Four Digit SIC Codes': 3493,
    'Four Digit SIC Code Descriptions': 'STEEL SPRINGS, EXCEPT WIRE',
  },
  {
    'Four Digit SIC Codes': 3494,
    'Four Digit SIC Code Descriptions': 'VALVES AND PIPE FITTINGS, NEC',
  },
  {
    'Four Digit SIC Codes': 3495,
    'Four Digit SIC Code Descriptions': 'WIRE SPRINGS',
  },
  {
    'Four Digit SIC Codes': 3496,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS FABRICATED WIRE PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3497,
    'Four Digit SIC Code Descriptions': 'METAL FOIL AND LEAF',
  },
  {
    'Four Digit SIC Codes': 3498,
    'Four Digit SIC Code Descriptions': 'FABRICATED PIPE AND FITTINGS',
  },
  {
    'Four Digit SIC Codes': 3499,
    'Four Digit SIC Code Descriptions': 'FABRICATED METAL PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 3511,
    'Four Digit SIC Code Descriptions': 'TURBINES AND TURBINE GENERATOR SETS',
  },
  {
    'Four Digit SIC Codes': 3519,
    'Four Digit SIC Code Descriptions': 'INTERNAL COMBUSTION ENGINES, NEC',
  },
  {
    'Four Digit SIC Codes': 3523,
    'Four Digit SIC Code Descriptions': 'FARM MACHINERY AND EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3524,
    'Four Digit SIC Code Descriptions': 'LAWN AND GARDEN EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3531,
    'Four Digit SIC Code Descriptions': 'CONSTRUCTION MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3532,
    'Four Digit SIC Code Descriptions': 'MINING MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3533,
    'Four Digit SIC Code Descriptions': 'OIL AND GAS FIELD MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3534,
    'Four Digit SIC Code Descriptions': 'ELEVATORS AND MOVING STAIRWAYS',
  },
  {
    'Four Digit SIC Codes': 3535,
    'Four Digit SIC Code Descriptions': 'CONVEYORS AND CONVEYING EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3536,
    'Four Digit SIC Code Descriptions': 'HOISTS, CRANES, AND MONORAILS',
  },
  {
    'Four Digit SIC Codes': 3537,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL TRUCKS AND TRACTORS',
  },
  {
    'Four Digit SIC Codes': 3541,
    'Four Digit SIC Code Descriptions': 'MACHINE TOOLS, METAL CUTTING TYPE',
  },
  {
    'Four Digit SIC Codes': 3542,
    'Four Digit SIC Code Descriptions': 'MACHINE TOOLS, METAL FORMING TYPE',
  },
  {
    'Four Digit SIC Codes': 3543,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL PATTERNS',
  },
  {
    'Four Digit SIC Codes': 3544,
    'Four Digit SIC Code Descriptions': 'SPECIAL DIES, TOOLS, JIGS, AND FIXTURES',
  },
  {
    'Four Digit SIC Codes': 3545,
    'Four Digit SIC Code Descriptions': 'MACHINE TOOL ACCESSORIES',
  },
  {
    'Four Digit SIC Codes': 3546,
    'Four Digit SIC Code Descriptions': 'POWER-DRIVEN HANDTOOLS',
  },
  {
    'Four Digit SIC Codes': 3547,
    'Four Digit SIC Code Descriptions': 'ROLLING MILL MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3548,
    'Four Digit SIC Code Descriptions': 'WELDING APPARATUS',
  },
  {
    'Four Digit SIC Codes': 3549,
    'Four Digit SIC Code Descriptions': 'METALWORKING MACHINERY, NEC',
  },
  {
    'Four Digit SIC Codes': 3552,
    'Four Digit SIC Code Descriptions': 'TEXTILE MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3553,
    'Four Digit SIC Code Descriptions': 'WOODWORKING MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3554,
    'Four Digit SIC Code Descriptions': 'PAPER INDUSTRIES MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3555,
    'Four Digit SIC Code Descriptions': 'PRINTING TRADES MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3556,
    'Four Digit SIC Code Descriptions': 'FOOD PRODUCTS MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3559,
    'Four Digit SIC Code Descriptions': 'SPECIAL INDUSTRY MACHINERY, NEC',
  },
  {
    'Four Digit SIC Codes': 3561,
    'Four Digit SIC Code Descriptions': 'PUMPS AND PUMPING EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3562,
    'Four Digit SIC Code Descriptions': 'BALL AND ROLLER BEARINGS',
  },
  {
    'Four Digit SIC Codes': 3563,
    'Four Digit SIC Code Descriptions': 'AIR AND GAS COMPRESSORS',
  },
  {
    'Four Digit SIC Codes': 3564,
    'Four Digit SIC Code Descriptions': 'BLOWERS AND FANS',
  },
  {
    'Four Digit SIC Codes': 3565,
    'Four Digit SIC Code Descriptions': 'PACKAGING MACHINERY',
  },
  {
    'Four Digit SIC Codes': 3566,
    'Four Digit SIC Code Descriptions': 'SPEED CHANGERS, DRIVES, AND GEARS',
  },
  {
    'Four Digit SIC Codes': 3567,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL FURNACES AND OVENS',
  },
  {
    'Four Digit SIC Codes': 3568,
    'Four Digit SIC Code Descriptions': 'POWER TRANSMISSION EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 3569,
    'Four Digit SIC Code Descriptions': 'GENERAL INDUSTRIAL MACHINERY,',
  },
  {
    'Four Digit SIC Codes': 3571,
    'Four Digit SIC Code Descriptions': 'ELECTRONIC COMPUTERS',
  },
  {
    'Four Digit SIC Codes': 3572,
    'Four Digit SIC Code Descriptions': 'COMPUTER STORAGE DEVICES',
  },
  {
    'Four Digit SIC Codes': 3575,
    'Four Digit SIC Code Descriptions': 'COMPUTER TERMINALS',
  },
  {
    'Four Digit SIC Codes': 3577,
    'Four Digit SIC Code Descriptions': 'COMPUTER PERIPHERAL EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 3578,
    'Four Digit SIC Code Descriptions': 'CALCULATING AND ACCOUNTING EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3579,
    'Four Digit SIC Code Descriptions': 'OFFICE MACHINES, NEC',
  },
  {
    'Four Digit SIC Codes': 3581,
    'Four Digit SIC Code Descriptions': 'AUTOMATIC VENDING MACHINES',
  },
  {
    'Four Digit SIC Codes': 3582,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL LAUNDRY EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3585,
    'Four Digit SIC Code Descriptions': 'REFRIGERATION AND HEATING EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3586,
    'Four Digit SIC Code Descriptions': 'MEASURING AND DISPENSING PUMPS',
  },
  {
    'Four Digit SIC Codes': 3589,
    'Four Digit SIC Code Descriptions': 'SERVICE INDUSTRY MACHINERY, NEC',
  },
  {
    'Four Digit SIC Codes': 3592,
    'Four Digit SIC Code Descriptions': 'CARBURETORS, PISTONS, RINGS, VALVES',
  },
  {
    'Four Digit SIC Codes': 3593,
    'Four Digit SIC Code Descriptions': 'FLUID POWER CYLINDERS AND ACTUATORS',
  },
  {
    'Four Digit SIC Codes': 3594,
    'Four Digit SIC Code Descriptions': 'FLUID POWER PUMPS AND MOTORS',
  },
  {
    'Four Digit SIC Codes': 3596,
    'Four Digit SIC Code Descriptions': 'SCALES AND BALANCES, EXCEPT LABORATORY',
  },
  {
    'Four Digit SIC Codes': 3599,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL MACHINERY, NEC',
  },
  {
    'Four Digit SIC Codes': 3612,
    'Four Digit SIC Code Descriptions': 'TRANSFORMERS, EXCEPT ELECTRIC',
  },
  {
    'Four Digit SIC Codes': 3613,
    'Four Digit SIC Code Descriptions': 'SWITCHGEAR AND SWITCHBOARD APPARATUS',
  },
  {
    'Four Digit SIC Codes': 3621,
    'Four Digit SIC Code Descriptions': 'MOTORS AND GENERATORS',
  },
  {
    'Four Digit SIC Codes': 3624,
    'Four Digit SIC Code Descriptions': 'CARBON AND GRAPHITE PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 3625,
    'Four Digit SIC Code Descriptions': 'RELAYS AND INDUSTRIAL CONTROLS',
  },
  {
    'Four Digit SIC Codes': 3629,
    'Four Digit SIC Code Descriptions': 'ELECTRICAL INDUSTRIAL APPARATUS',
  },
  {
    'Four Digit SIC Codes': 3631,
    'Four Digit SIC Code Descriptions': 'HOUSEHOLD COOKING EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3632,
    'Four Digit SIC Code Descriptions': 'HOUSEHOLD REFRIGERATORS AND FREEZERS',
  },
  {
    'Four Digit SIC Codes': 3633,
    'Four Digit SIC Code Descriptions': 'HOUSEHOLD LAUNDRY EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3634,
    'Four Digit SIC Code Descriptions': 'ELECTRIC HOUSEWARES AND FANS',
  },
  {
    'Four Digit SIC Codes': 3635,
    'Four Digit SIC Code Descriptions': 'HOUSEHOLD VACUUM CLEANERS',
  },
  {
    'Four Digit SIC Codes': 3639,
    'Four Digit SIC Code Descriptions': 'HOUSEHOLD APPLIANCES, NEC',
  },
  {
    'Four Digit SIC Codes': 3641,
    'Four Digit SIC Code Descriptions': 'ELECTRIC LAMPS',
  },
  {
    'Four Digit SIC Codes': 3643,
    'Four Digit SIC Code Descriptions': 'CURRENT-CARRYING WIRING DEVICES',
  },
  {
    'Four Digit SIC Codes': 3644,
    'Four Digit SIC Code Descriptions': 'NONCURRENT-CARRYING WIRING DEVICES',
  },
  {
    'Four Digit SIC Codes': 3645,
    'Four Digit SIC Code Descriptions': 'RESIDENTIAL LIGHTING FIXTURES',
  },
  {
    'Four Digit SIC Codes': 3646,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL LIGHTING FIXTURES',
  },
  {
    'Four Digit SIC Codes': 3647,
    'Four Digit SIC Code Descriptions': 'VEHICULAR LIGHTING EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3648,
    'Four Digit SIC Code Descriptions': 'LIGHTING EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 3651,
    'Four Digit SIC Code Descriptions': 'HOUSEHOLD AUDIO AND VIDEO EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3652,
    'Four Digit SIC Code Descriptions': 'PRERECORDED RECORDS AND TAPES',
  },
  {
    'Four Digit SIC Codes': 3661,
    'Four Digit SIC Code Descriptions': 'TELEPHONE AND TELEGRAPH APPARATUS',
  },
  {
    'Four Digit SIC Codes': 3663,
    'Four Digit SIC Code Descriptions': 'RADIO AND T.V. COMMUNICATIONS EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3669,
    'Four Digit SIC Code Descriptions': 'COMMUNICATIONS EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 3671,
    'Four Digit SIC Code Descriptions': 'ELECTRON TUBES',
  },
  {
    'Four Digit SIC Codes': 3672,
    'Four Digit SIC Code Descriptions': 'PRINTED CIRCUIT BOARDS',
  },
  {
    'Four Digit SIC Codes': 3674,
    'Four Digit SIC Code Descriptions': 'SEMICONDUCTORS AND RELATED DEVICES',
  },
  {
    'Four Digit SIC Codes': 3675,
    'Four Digit SIC Code Descriptions': 'ELECTRONIC CAPACITORS',
  },
  {
    'Four Digit SIC Codes': 3676,
    'Four Digit SIC Code Descriptions': 'ELECTRONIC RESISTORS',
  },
  {
    'Four Digit SIC Codes': 3677,
    'Four Digit SIC Code Descriptions': 'ELECTRONIC COILS AND TRANSFORMERS',
  },
  {
    'Four Digit SIC Codes': 3678,
    'Four Digit SIC Code Descriptions': 'ELECTRONIC CONNECTORS',
  },
  {
    'Four Digit SIC Codes': 3679,
    'Four Digit SIC Code Descriptions': 'ELECTRONIC COMPONENTS, NEC',
  },
  {
    'Four Digit SIC Codes': 3691,
    'Four Digit SIC Code Descriptions': 'STORAGE BATTERIES',
  },
  {
    'Four Digit SIC Codes': 3692,
    'Four Digit SIC Code Descriptions': 'PRIMARY BATTERIES, DRY AND WET',
  },
  {
    'Four Digit SIC Codes': 3694,
    'Four Digit SIC Code Descriptions': 'ENGINE ELECTRICAL EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3695,
    'Four Digit SIC Code Descriptions': 'MAGNETIC AND OPTICAL RECORDING MEDIA',
  },
  {
    'Four Digit SIC Codes': 3699,
    'Four Digit SIC Code Descriptions': 'ELECTRICAL EQUIPMENT AND SUPPLIES, NEC',
  },
  {
    'Four Digit SIC Codes': 3711,
    'Four Digit SIC Code Descriptions': 'MOTOR VEHICLES AND CAR BODIES',
  },
  {
    'Four Digit SIC Codes': 3713,
    'Four Digit SIC Code Descriptions': 'TRUCK AND BUS BODIES',
  },
  {
    'Four Digit SIC Codes': 3714,
    'Four Digit SIC Code Descriptions': 'MOTOR VEHICLE PARTS AND ACCESSORIES',
  },
  {
    'Four Digit SIC Codes': 3715,
    'Four Digit SIC Code Descriptions': 'TRUCK TRAILERS',
  },
  {
    'Four Digit SIC Codes': 3716,
    'Four Digit SIC Code Descriptions': 'MOTOR HOMES',
  },
  {
    'Four Digit SIC Codes': 3721,
    'Four Digit SIC Code Descriptions': 'AIRCRAFT',
  },
  {
    'Four Digit SIC Codes': 3724,
    'Four Digit SIC Code Descriptions': 'AIRCRAFT ENGINES AND ENGINE PARTS',
  },
  {
    'Four Digit SIC Codes': 3728,
    'Four Digit SIC Code Descriptions': 'AIRCRAFT PARTS AND EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 3731,
    'Four Digit SIC Code Descriptions': 'SHIPBUILDING AND REPAIRING',
  },
  {
    'Four Digit SIC Codes': 3732,
    'Four Digit SIC Code Descriptions': 'BOATBUILDING AND REPAIRING',
  },
  {
    'Four Digit SIC Codes': 3743,
    'Four Digit SIC Code Descriptions': 'RAILROAD EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3751,
    'Four Digit SIC Code Descriptions': 'MOTORCYCLES, BICYCLES, AND PARTS',
  },
  {
    'Four Digit SIC Codes': 3761,
    'Four Digit SIC Code Descriptions': 'GUIDED MISSILES AND SPACE VEHICLES',
  },
  {
    'Four Digit SIC Codes': 3764,
    'Four Digit SIC Code Descriptions': 'SPACE PROPULSION UNITS AND PARTS',
  },
  {
    'Four Digit SIC Codes': 3769,
    'Four Digit SIC Code Descriptions': 'SPACE VEHICLE EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 3792,
    'Four Digit SIC Code Descriptions': 'TRAVEL TRAILERS AND CAMPERS',
  },
  {
    'Four Digit SIC Codes': 3795,
    'Four Digit SIC Code Descriptions': 'TANKS AND TANK COMPONENTS',
  },
  {
    'Four Digit SIC Codes': 3799,
    'Four Digit SIC Code Descriptions': 'TRANSPORTATION EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 3812,
    'Four Digit SIC Code Descriptions': 'SEARCH AND NAVIGATION EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3821,
    'Four Digit SIC Code Descriptions': 'LABORATORY APPARATUS AND FURNITURE',
  },
  {
    'Four Digit SIC Codes': 3822,
    'Four Digit SIC Code Descriptions': 'ENVIRONMENTAL CONTROLS',
  },
  {
    'Four Digit SIC Codes': 3823,
    'Four Digit SIC Code Descriptions': 'PROCESS CONTROL INSTRUMENTS',
  },
  {
    'Four Digit SIC Codes': 3824,
    'Four Digit SIC Code Descriptions': 'FLUID METERS AND COUNTING DEVICES',
  },
  {
    'Four Digit SIC Codes': 3825,
    'Four Digit SIC Code Descriptions': 'INSTRUMENTS TO MEASURE ELECTRICITY',
  },
  {
    'Four Digit SIC Codes': 3826,
    'Four Digit SIC Code Descriptions': 'ANALYTICAL INSTRUMENTS',
  },
  {
    'Four Digit SIC Codes': 3827,
    'Four Digit SIC Code Descriptions': 'OPTICAL INSTRUMENTS AND LENSES',
  },
  {
    'Four Digit SIC Codes': 3829,
    'Four Digit SIC Code Descriptions': 'MEASURING AND CONTROLLING DEVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 3841,
    'Four Digit SIC Code Descriptions': 'SURGICAL AND MEDICAL INSTRUMENTS',
  },
  {
    'Four Digit SIC Codes': 3842,
    'Four Digit SIC Code Descriptions': 'SURGICAL APPLIANCES AND SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 3843,
    'Four Digit SIC Code Descriptions': 'DENTAL EQUIPMENT AND SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 3844,
    'Four Digit SIC Code Descriptions': 'X-RAY APPARATUS AND TUBES',
  },
  {
    'Four Digit SIC Codes': 3845,
    'Four Digit SIC Code Descriptions': 'ELECTROMEDICAL EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 3851,
    'Four Digit SIC Code Descriptions': 'OPHTHALMIC GOODS',
  },
  {
    'Four Digit SIC Codes': 3861,
    'Four Digit SIC Code Descriptions': 'PHOTOGRAPHIC EQUIPMENT AND SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 3873,
    'Four Digit SIC Code Descriptions': 'WATCHES, CLOCKS, WATCHCASES, AND PARTS',
  },
  {
    'Four Digit SIC Codes': 3911,
    'Four Digit SIC Code Descriptions': 'JEWELRY, PRECIOUS METAL',
  },
  {
    'Four Digit SIC Codes': 3914,
    'Four Digit SIC Code Descriptions': 'SILVERWARE AND PLATED WARE',
  },
  {
    'Four Digit SIC Codes': 3915,
    'Four Digit SIC Code Descriptions': "JEWELERS' MATERIALS AND LAPIDARY WORK",
  },
  {
    'Four Digit SIC Codes': 3931,
    'Four Digit SIC Code Descriptions': 'MUSICAL INSTRUMENTS',
  },
  {
    'Four Digit SIC Codes': 3942,
    'Four Digit SIC Code Descriptions': 'DOLLS AND STUFFED TOYS',
  },
  {
    'Four Digit SIC Codes': 3944,
    'Four Digit SIC Code Descriptions': "GAMES, TOYS, AND CHILDREN'S VEHICLES",
  },
  {
    'Four Digit SIC Codes': 3949,
    'Four Digit SIC Code Descriptions': 'SPORTING AND ATHLETIC GOODS, NEC',
  },
  {
    'Four Digit SIC Codes': 3951,
    'Four Digit SIC Code Descriptions': 'PENS AND MECHANICAL PENCILS',
  },
  {
    'Four Digit SIC Codes': 3952,
    'Four Digit SIC Code Descriptions': 'LEAD PENCILS AND ART GOODS',
  },
  {
    'Four Digit SIC Codes': 3953,
    'Four Digit SIC Code Descriptions': 'MARKING DEVICES',
  },
  {
    'Four Digit SIC Codes': 3955,
    'Four Digit SIC Code Descriptions': 'CARBON PAPER AND INKED RIBBONS',
  },
  {
    'Four Digit SIC Codes': 3961,
    'Four Digit SIC Code Descriptions': 'COSTUME JEWELRY',
  },
  {
    'Four Digit SIC Codes': 3965,
    'Four Digit SIC Code Descriptions': 'FASTENERS, BUTTONS, NEEDLES, AND PINS',
  },
  {
    'Four Digit SIC Codes': 3991,
    'Four Digit SIC Code Descriptions': 'BROOMS AND BRUSHES',
  },
  {
    'Four Digit SIC Codes': 3993,
    'Four Digit SIC Code Descriptions': 'SIGNS AND ADVERTISING SPECIALTIES',
  },
  {
    'Four Digit SIC Codes': 3995,
    'Four Digit SIC Code Descriptions': 'BURIAL CASKETS',
  },
  {
    'Four Digit SIC Codes': 3996,
    'Four Digit SIC Code Descriptions': 'HARD SURFACE FLOOR COVERINGS, NEC',
  },
  {
    'Four Digit SIC Codes': 3999,
    'Four Digit SIC Code Descriptions': 'MANUFACTURING INDUSTRIES, NEC',
  },
  {
    'Four Digit SIC Codes': 4011,
    'Four Digit SIC Code Descriptions': 'RAILROADS, LINE-HAUL OPERATING',
  },
  {
    'Four Digit SIC Codes': 4013,
    'Four Digit SIC Code Descriptions': 'SWITCHING AND TERMINAL SERVICES',
  },
  {
    'Four Digit SIC Codes': 4111,
    'Four Digit SIC Code Descriptions': 'LOCAL AND SUBURBAN TRANSIT',
  },
  {
    'Four Digit SIC Codes': 4119,
    'Four Digit SIC Code Descriptions': 'LOCAL PASSENGER TRANSPORTATION, NEC',
  },
  {
    'Four Digit SIC Codes': 4121,
    'Four Digit SIC Code Descriptions': 'TAXICABS',
  },
  {
    'Four Digit SIC Codes': 4131,
    'Four Digit SIC Code Descriptions': 'INTERCITY AND RURAL BUS TRANSPORTATION',
  },
  {
    'Four Digit SIC Codes': 4141,
    'Four Digit SIC Code Descriptions': 'LOCAL BUS CHARTER SERVICE',
  },
  {
    'Four Digit SIC Codes': 4142,
    'Four Digit SIC Code Descriptions': 'BUS CHARTER SERVICE, EXCEPT LOCAL',
  },
  {
    'Four Digit SIC Codes': 4151,
    'Four Digit SIC Code Descriptions': 'SCHOOL BUSES',
  },
  {
    'Four Digit SIC Codes': 4173,
    'Four Digit SIC Code Descriptions': 'BUS TERMINAL AND SERVICE FACILITIES',
  },
  {
    'Four Digit SIC Codes': 4212,
    'Four Digit SIC Code Descriptions': 'LOCAL TRUCKING, WITHOUT STORAGE',
  },
  {
    'Four Digit SIC Codes': 4213,
    'Four Digit SIC Code Descriptions': 'TRUCKING, EXCEPT LOCAL',
  },
  {
    'Four Digit SIC Codes': 4214,
    'Four Digit SIC Code Descriptions': 'LOCAL TRUCKING WITH STORAGE',
  },
  {
    'Four Digit SIC Codes': 4215,
    'Four Digit SIC Code Descriptions': 'COURIER SERVICES, EXCEPT BY AIR',
  },
  {
    'Four Digit SIC Codes': 4221,
    'Four Digit SIC Code Descriptions': 'FARM PRODUCT WAREHOUSING AND STORAGE',
  },
  {
    'Four Digit SIC Codes': 4222,
    'Four Digit SIC Code Descriptions': 'REFRIGERATED WAREHOUSING AND STORAGE',
  },
  {
    'Four Digit SIC Codes': 4225,
    'Four Digit SIC Code Descriptions': 'GENERAL WAREHOUSING AND STORAGE',
  },
  {
    'Four Digit SIC Codes': 4226,
    'Four Digit SIC Code Descriptions': 'SPECIAL WAREHOUSING AND STORAGE, NEC',
  },
  {
    'Four Digit SIC Codes': 4231,
    'Four Digit SIC Code Descriptions': 'TRUCKING TERMINAL FACILITIES',
  },
  {
    'Four Digit SIC Codes': 4311,
    'Four Digit SIC Code Descriptions': 'U.S. POSTAL SERVICE',
  },
  {
    'Four Digit SIC Codes': 4412,
    'Four Digit SIC Code Descriptions': 'DEEP SEA FOREIGN TRANSPORTATION OF FREIGHT',
  },
  {
    'Four Digit SIC Codes': 4424,
    'Four Digit SIC Code Descriptions': 'DEEP SEA DOMESTIC TRANSPORTATION OF FREIGHT',
  },
  {
    'Four Digit SIC Codes': 4432,
    'Four Digit SIC Code Descriptions': 'FREIGHT TRANSPORTATION ON THE GREAT LAKES',
  },
  {
    'Four Digit SIC Codes': 4449,
    'Four Digit SIC Code Descriptions': 'WATER TRANSPORTATION OF FREIGHT',
  },
  {
    'Four Digit SIC Codes': 4481,
    'Four Digit SIC Code Descriptions': 'DEEP SEA PASSENGER TRANSPORTATION, EXCEPT FERRY',
  },
  {
    'Four Digit SIC Codes': 4482,
    'Four Digit SIC Code Descriptions': 'FERRIES',
  },
  {
    'Four Digit SIC Codes': 4489,
    'Four Digit SIC Code Descriptions': 'WATER PASSENGER TRANSPORTATION',
  },
  {
    'Four Digit SIC Codes': 4491,
    'Four Digit SIC Code Descriptions': 'MARINE CARGO HANDLING',
  },
  {
    'Four Digit SIC Codes': 4492,
    'Four Digit SIC Code Descriptions': 'TOWING AND TUGBOAT SERVICE',
  },
  {
    'Four Digit SIC Codes': 4493,
    'Four Digit SIC Code Descriptions': 'MARINAS',
  },
  {
    'Four Digit SIC Codes': 4499,
    'Four Digit SIC Code Descriptions': 'WATER TRANSPORTATION SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 4512,
    'Four Digit SIC Code Descriptions': 'AIR TRANSPORTATION, SCHEDULED',
  },
  {
    'Four Digit SIC Codes': 4513,
    'Four Digit SIC Code Descriptions': 'AIR COURIER SERVICES',
  },
  {
    'Four Digit SIC Codes': 4522,
    'Four Digit SIC Code Descriptions': 'AIR TRANSPORTATION, NONSCHEDULED',
  },
  {
    'Four Digit SIC Codes': 4581,
    'Four Digit SIC Code Descriptions': 'AIRPORTS, FLYING FIELDS, AND SERVICES',
  },
  {
    'Four Digit SIC Codes': 4612,
    'Four Digit SIC Code Descriptions': 'CRUDE PETROLEUM PIPELINES',
  },
  {
    'Four Digit SIC Codes': 4613,
    'Four Digit SIC Code Descriptions': 'REFINED PETROLEUM PIPELINES',
  },
  {
    'Four Digit SIC Codes': 4619,
    'Four Digit SIC Code Descriptions': 'PIPELINES, NEC',
  },
  {
    'Four Digit SIC Codes': 4724,
    'Four Digit SIC Code Descriptions': 'TRAVEL AGENCIES',
  },
  {
    'Four Digit SIC Codes': 4725,
    'Four Digit SIC Code Descriptions': 'TOUR OPERATORS',
  },
  {
    'Four Digit SIC Codes': 4729,
    'Four Digit SIC Code Descriptions': 'PASSENGER TRANSPORTATION ARRANGEMENT',
  },
  {
    'Four Digit SIC Codes': 4731,
    'Four Digit SIC Code Descriptions': 'FREIGHT TRANSPORTATION ARRANGEMENT',
  },
  {
    'Four Digit SIC Codes': 4741,
    'Four Digit SIC Code Descriptions': 'RENTAL OF RAILROAD CARS',
  },
  {
    'Four Digit SIC Codes': 4783,
    'Four Digit SIC Code Descriptions': 'PACKING AND CRATING',
  },
  {
    'Four Digit SIC Codes': 4785,
    'Four Digit SIC Code Descriptions': 'INSPECTION AND FIXED FACILITIES',
  },
  {
    'Four Digit SIC Codes': 4789,
    'Four Digit SIC Code Descriptions': 'TRANSPORTATION SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 4812,
    'Four Digit SIC Code Descriptions': 'RADIOTELEPHONE COMMUNICATION',
  },
  {
    'Four Digit SIC Codes': 4813,
    'Four Digit SIC Code Descriptions': 'TELEPHONE COMMUNICATION, EXCEPT RADIO',
  },
  {
    'Four Digit SIC Codes': 4822,
    'Four Digit SIC Code Descriptions': 'TELEGRAPH AND OTHER COMMUNICATIONS',
  },
  {
    'Four Digit SIC Codes': 4832,
    'Four Digit SIC Code Descriptions': 'RADIO BROADCASTING STATIONS',
  },
  {
    'Four Digit SIC Codes': 4833,
    'Four Digit SIC Code Descriptions': 'TELEVISION BROADCASTING STATIONS',
  },
  {
    'Four Digit SIC Codes': 4841,
    'Four Digit SIC Code Descriptions': 'CABLE AND OTHER PAY TELEVISION SERVICES',
  },
  {
    'Four Digit SIC Codes': 4899,
    'Four Digit SIC Code Descriptions': 'COMMUNICATION SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 4911,
    'Four Digit SIC Code Descriptions': 'ELECTRIC SERVICES',
  },
  {
    'Four Digit SIC Codes': 4922,
    'Four Digit SIC Code Descriptions': 'NATURAL GAS TRANSMISSION',
  },
  {
    'Four Digit SIC Codes': 4923,
    'Four Digit SIC Code Descriptions': 'GAS TRANSMISSION AND DISTRIBUTION',
  },
  {
    'Four Digit SIC Codes': 4924,
    'Four Digit SIC Code Descriptions': 'NATURAL GAS DISTRIBUTION',
  },
  {
    'Four Digit SIC Codes': 4925,
    'Four Digit SIC Code Descriptions': 'GAS PRODUCTION AND/OR DISTRIBUTION',
  },
  {
    'Four Digit SIC Codes': 4931,
    'Four Digit SIC Code Descriptions': 'ELECTRIC AND OTHER SERVICES COMBINED',
  },
  {
    'Four Digit SIC Codes': 4932,
    'Four Digit SIC Code Descriptions': 'GAS AND OTHER SERVICES COMBINED',
  },
  {
    'Four Digit SIC Codes': 4939,
    'Four Digit SIC Code Descriptions': 'COMBINATION UTILITIES, NEC',
  },
  {
    'Four Digit SIC Codes': 4941,
    'Four Digit SIC Code Descriptions': 'WATER SUPPLY',
  },
  {
    'Four Digit SIC Codes': 4952,
    'Four Digit SIC Code Descriptions': 'SEWERAGE SYSTEMS',
  },
  {
    'Four Digit SIC Codes': 4953,
    'Four Digit SIC Code Descriptions': 'REFUSE SYSTEMS',
  },
  {
    'Four Digit SIC Codes': 4959,
    'Four Digit SIC Code Descriptions': 'SANITARY SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 4961,
    'Four Digit SIC Code Descriptions': 'STEAM AND AIR-CONDITIONING SUPPLY',
  },
  {
    'Four Digit SIC Codes': 4971,
    'Four Digit SIC Code Descriptions': 'IRRIGATION SYSTEMS',
  },
  {
    'Four Digit SIC Codes': 5012,
    'Four Digit SIC Code Descriptions': 'AUTOMOBILES AND OTHER MOTOR VEHICLES',
  },
  {
    'Four Digit SIC Codes': 5013,
    'Four Digit SIC Code Descriptions': 'MOTOR VEHICLE SUPPLIES AND NEW PARTS',
  },
  {
    'Four Digit SIC Codes': 5014,
    'Four Digit SIC Code Descriptions': 'TIRES AND TUBES',
  },
  {
    'Four Digit SIC Codes': 5015,
    'Four Digit SIC Code Descriptions': 'MOTOR VEHICLE PARTS, USED',
  },
  {
    'Four Digit SIC Codes': 5021,
    'Four Digit SIC Code Descriptions': 'FURNITURE',
  },
  {
    'Four Digit SIC Codes': 5023,
    'Four Digit SIC Code Descriptions': 'HOMEFURNISHINGS',
  },
  {
    'Four Digit SIC Codes': 5031,
    'Four Digit SIC Code Descriptions': 'LUMBER, PLYWOOD, AND MILLWORK',
  },
  {
    'Four Digit SIC Codes': 5032,
    'Four Digit SIC Code Descriptions': 'BRICK, STONE, AND RELATED MATERIAL',
  },
  {
    'Four Digit SIC Codes': 5033,
    'Four Digit SIC Code Descriptions': 'ROOFING, SIDING, AND INSULATION',
  },
  {
    'Four Digit SIC Codes': 5039,
    'Four Digit SIC Code Descriptions': 'CONSTRUCTION MATERIALS, NEC',
  },
  {
    'Four Digit SIC Codes': 5043,
    'Four Digit SIC Code Descriptions': 'PHOTOGRAPHIC EQUIPMENT AND SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5044,
    'Four Digit SIC Code Descriptions': 'OFFICE EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 5045,
    'Four Digit SIC Code Descriptions': 'COMPUTERS, PERIPHERALS, AND SOFTWARE',
  },
  {
    'Four Digit SIC Codes': 5046,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 5047,
    'Four Digit SIC Code Descriptions': 'MEDICAL AND HOSPITAL EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 5048,
    'Four Digit SIC Code Descriptions': 'OPHTHALMIC GOODS',
  },
  {
    'Four Digit SIC Codes': 5049,
    'Four Digit SIC Code Descriptions': 'PROFESSIONAL EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 5051,
    'Four Digit SIC Code Descriptions': 'METALS SERVICE CENTERS AND OFFICES',
  },
  {
    'Four Digit SIC Codes': 5052,
    'Four Digit SIC Code Descriptions': 'COAL AND OTHER MINERALS AND ORES',
  },
  {
    'Four Digit SIC Codes': 5063,
    'Four Digit SIC Code Descriptions': 'ELECTRICAL APPARATUS AND EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 5064,
    'Four Digit SIC Code Descriptions': 'ELECTRICAL APPLIANCES, TELEVISION AND RADIO',
  },
  {
    'Four Digit SIC Codes': 5065,
    'Four Digit SIC Code Descriptions': 'ELECTRONIC PARTS AND EQUIPMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 5072,
    'Four Digit SIC Code Descriptions': 'HARDWARE',
  },
  {
    'Four Digit SIC Codes': 5074,
    'Four Digit SIC Code Descriptions': 'PLUMBING AND HYDRONIC HEATING SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5075,
    'Four Digit SIC Code Descriptions': 'WARM AIR HEATING AND AIR CONDITIONING',
  },
  {
    'Four Digit SIC Codes': 5078,
    'Four Digit SIC Code Descriptions': 'REFRIGERATION EQUIPMENT AND SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5082,
    'Four Digit SIC Code Descriptions': 'CONSTRUCTION AND MINING MACHINERY',
  },
  {
    'Four Digit SIC Codes': 5083,
    'Four Digit SIC Code Descriptions': 'FARM AND GARDEN MACHINERY',
  },
  {
    'Four Digit SIC Codes': 5084,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL MACHINERY AND EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 5085,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5087,
    'Four Digit SIC Code Descriptions': 'SERVICE ESTABLISHMENT EQUIPMENT',
  },
  {
    'Four Digit SIC Codes': 5088,
    'Four Digit SIC Code Descriptions': 'TRANSPORTATION EQUIPMENT AND SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5091,
    'Four Digit SIC Code Descriptions': 'SPORTING AND RECREATION GOODS',
  },
  {
    'Four Digit SIC Codes': 5092,
    'Four Digit SIC Code Descriptions': 'TOYS AND HOBBY GOODS AND SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5093,
    'Four Digit SIC Code Descriptions': 'SCRAP AND WASTE MATERIALS',
  },
  {
    'Four Digit SIC Codes': 5094,
    'Four Digit SIC Code Descriptions': 'JEWELRY AND PRECIOUS STONES',
  },
  {
    'Four Digit SIC Codes': 5099,
    'Four Digit SIC Code Descriptions': 'DURABLE GOODS, NEC',
  },
  {
    'Four Digit SIC Codes': 5111,
    'Four Digit SIC Code Descriptions': 'PRINTING AND WRITING PAPER',
  },
  {
    'Four Digit SIC Codes': 5112,
    'Four Digit SIC Code Descriptions': 'STATIONERY AND OFFICE SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5113,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL AND PERSONAL SERVICE PAPER',
  },
  {
    'Four Digit SIC Codes': 5122,
    'Four Digit SIC Code Descriptions': 'DRUGS, PROPRIETARIES, AND SUNDRIES',
  },
  {
    'Four Digit SIC Codes': 5131,
    'Four Digit SIC Code Descriptions': 'PIECE GOODS AND NOTIONS',
  },
  {
    'Four Digit SIC Codes': 5136,
    'Four Digit SIC Code Descriptions': "MEN'S AND BOY'S CLOTHING",
  },
  {
    'Four Digit SIC Codes': 5137,
    'Four Digit SIC Code Descriptions': "WOMEN'S AND CHILDREN'S CLOTHING",
  },
  {
    'Four Digit SIC Codes': 5139,
    'Four Digit SIC Code Descriptions': 'FOOTWEAR',
  },
  {
    'Four Digit SIC Codes': 5141,
    'Four Digit SIC Code Descriptions': 'GROCERIES, GENERAL LINE',
  },
  {
    'Four Digit SIC Codes': 5142,
    'Four Digit SIC Code Descriptions': 'PACKAGED FROZEN GOODS',
  },
  {
    'Four Digit SIC Codes': 5143,
    'Four Digit SIC Code Descriptions': 'DAIRY PRODUCTS, EXCEPT DRIED OR CANNED',
  },
  {
    'Four Digit SIC Codes': 5144,
    'Four Digit SIC Code Descriptions': 'POULTRY AND POULTRY PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 5145,
    'Four Digit SIC Code Descriptions': 'CONFECTIONERY',
  },
  {
    'Four Digit SIC Codes': 5146,
    'Four Digit SIC Code Descriptions': 'FISH AND SEAFOODS',
  },
  {
    'Four Digit SIC Codes': 5147,
    'Four Digit SIC Code Descriptions': 'MEATS AND MEAT PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 5148,
    'Four Digit SIC Code Descriptions': 'FRESH FRUITS AND VEGETABLES',
  },
  {
    'Four Digit SIC Codes': 5149,
    'Four Digit SIC Code Descriptions': 'GROCERIES AND RELATED PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 5153,
    'Four Digit SIC Code Descriptions': 'GRAIN AND FIELD BEANS',
  },
  {
    'Four Digit SIC Codes': 5154,
    'Four Digit SIC Code Descriptions': 'LIVESTOCK',
  },
  {
    'Four Digit SIC Codes': 5159,
    'Four Digit SIC Code Descriptions': 'FARM-PRODUCT RAW MATERIALS, NEC',
  },
  {
    'Four Digit SIC Codes': 5162,
    'Four Digit SIC Code Descriptions': 'PLASTICS MATERIALS AND BASIC SHAPES',
  },
  {
    'Four Digit SIC Codes': 5169,
    'Four Digit SIC Code Descriptions': 'CHEMICALS AND ALLIED PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 5171,
    'Four Digit SIC Code Descriptions': 'PETROLEUM BULK STATIONS AND TERMINALS',
  },
  {
    'Four Digit SIC Codes': 5172,
    'Four Digit SIC Code Descriptions': 'PETROLEUM PRODUCTS, NEC',
  },
  {
    'Four Digit SIC Codes': 5181,
    'Four Digit SIC Code Descriptions': 'BEER AND ALE',
  },
  {
    'Four Digit SIC Codes': 5182,
    'Four Digit SIC Code Descriptions': 'WINE AND DISTILLED BEVERAGES',
  },
  {
    'Four Digit SIC Codes': 5191,
    'Four Digit SIC Code Descriptions': 'FARM SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5192,
    'Four Digit SIC Code Descriptions': 'BOOKS, PERIODICALS, AND NEWSPAPERS',
  },
  {
    'Four Digit SIC Codes': 5193,
    'Four Digit SIC Code Descriptions': 'FLOWERS AND FLORISTS SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5194,
    'Four Digit SIC Code Descriptions': 'TOBACCO AND TOBACCO PRODUCTS',
  },
  {
    'Four Digit SIC Codes': 5198,
    'Four Digit SIC Code Descriptions': 'PAINTS, VARNISHES, AND SUPPLIES',
  },
  {
    'Four Digit SIC Codes': 5199,
    'Four Digit SIC Code Descriptions': 'NONDURABLE GOODS, NEC',
  },
  {
    'Four Digit SIC Codes': 5211,
    'Four Digit SIC Code Descriptions': 'LUMBER AND OTHER BUILDING MATERIALS',
  },
  {
    'Four Digit SIC Codes': 5231,
    'Four Digit SIC Code Descriptions': 'PAINT, GLASS, AND WALLPAPER STORES',
  },
  {
    'Four Digit SIC Codes': 5251,
    'Four Digit SIC Code Descriptions': 'HARDWARE STORES',
  },
  {
    'Four Digit SIC Codes': 5261,
    'Four Digit SIC Code Descriptions': 'RETAIL NURSERIES AND GARDEN STORES',
  },
  {
    'Four Digit SIC Codes': 5271,
    'Four Digit SIC Code Descriptions': 'MOBILE HOME DEALERS',
  },
  {
    'Four Digit SIC Codes': 5311,
    'Four Digit SIC Code Descriptions': 'DEPARTMENT STORES',
  },
  {
    'Four Digit SIC Codes': 5331,
    'Four Digit SIC Code Descriptions': 'VARIETY STORES',
  },
  {
    'Four Digit SIC Codes': 5399,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS GENERAL MERCHANDISE',
  },
  {
    'Four Digit SIC Codes': 5411,
    'Four Digit SIC Code Descriptions': 'GROCERY STORES',
  },
  {
    'Four Digit SIC Codes': 5421,
    'Four Digit SIC Code Descriptions': 'MEAT AND FISH MARKETS',
  },
  {
    'Four Digit SIC Codes': 5431,
    'Four Digit SIC Code Descriptions': 'FRUIT AND VEGETABLE MARKETS',
  },
  {
    'Four Digit SIC Codes': 5441,
    'Four Digit SIC Code Descriptions': 'CANDY, NUT, AND CONFECTIONERY STORES',
  },
  {
    'Four Digit SIC Codes': 5451,
    'Four Digit SIC Code Descriptions': 'DAIRY PRODUCTS STORES',
  },
  {
    'Four Digit SIC Codes': 5461,
    'Four Digit SIC Code Descriptions': 'RETAIL BAKERIES',
  },
  {
    'Four Digit SIC Codes': 5499,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS FOOD STORES',
  },
  {
    'Four Digit SIC Codes': 5511,
    'Four Digit SIC Code Descriptions': 'NEW AND USED CAR DEALERS',
  },
  {
    'Four Digit SIC Codes': 5521,
    'Four Digit SIC Code Descriptions': 'USED CAR DEALERS',
  },
  {
    'Four Digit SIC Codes': 5531,
    'Four Digit SIC Code Descriptions': 'AUTO AND HOME SUPPLY STORES',
  },
  {
    'Four Digit SIC Codes': 5541,
    'Four Digit SIC Code Descriptions': 'GASOLINE SERVICE STATIONS',
  },
  {
    'Four Digit SIC Codes': 5551,
    'Four Digit SIC Code Descriptions': 'BOAT DEALERS',
  },
  {
    'Four Digit SIC Codes': 5561,
    'Four Digit SIC Code Descriptions': 'RECREATIONAL VEHICLE DEALERS',
  },
  {
    'Four Digit SIC Codes': 5571,
    'Four Digit SIC Code Descriptions': 'MOTORCYCLE DEALERS',
  },
  {
    'Four Digit SIC Codes': 5599,
    'Four Digit SIC Code Descriptions': 'AUTOMOTIVE DEALERS, NEC',
  },
  {
    'Four Digit SIC Codes': 5611,
    'Four Digit SIC Code Descriptions': "MEN'S AND BOYS' CLOTHING STORES",
  },
  {
    'Four Digit SIC Codes': 5621,
    'Four Digit SIC Code Descriptions': "WOMEN'S CLOTHING STORES",
  },
  {
    'Four Digit SIC Codes': 5632,
    'Four Digit SIC Code Descriptions': "WOMEN'S ACCESSORY AND SPECIALTY STORES",
  },
  {
    'Four Digit SIC Codes': 5641,
    'Four Digit SIC Code Descriptions': "CHILDREN'S AND INFANTS' WEAR STORES",
  },
  {
    'Four Digit SIC Codes': 5651,
    'Four Digit SIC Code Descriptions': 'FAMILY CLOTHING STORES',
  },
  {
    'Four Digit SIC Codes': 5661,
    'Four Digit SIC Code Descriptions': 'SHOE STORES',
  },
  {
    'Four Digit SIC Codes': 5699,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS APPAREL AND ACCESSORIES',
  },
  {
    'Four Digit SIC Codes': 5712,
    'Four Digit SIC Code Descriptions': 'FURNITURE STORES',
  },
  {
    'Four Digit SIC Codes': 5713,
    'Four Digit SIC Code Descriptions': 'FLOOR COVERING STORES',
  },
  {
    'Four Digit SIC Codes': 5714,
    'Four Digit SIC Code Descriptions': 'DRAPERY AND UPHOLSTERY STORES',
  },
  {
    'Four Digit SIC Codes': 5719,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS HOMEFURNISHINGS',
  },
  {
    'Four Digit SIC Codes': 5722,
    'Four Digit SIC Code Descriptions': 'HOUSEHOLD APPLIANCE STORES',
  },
  {
    'Four Digit SIC Codes': 5731,
    'Four Digit SIC Code Descriptions': 'RADIO, TELEVISION, AND ELECTRONIC STORES',
  },
  {
    'Four Digit SIC Codes': 5734,
    'Four Digit SIC Code Descriptions': 'COMPUTER AND SOFTWARE STORES',
  },
  {
    'Four Digit SIC Codes': 5735,
    'Four Digit SIC Code Descriptions': 'RECORD AND PRERECORDED TAPE STORES',
  },
  {
    'Four Digit SIC Codes': 5736,
    'Four Digit SIC Code Descriptions': 'MUSICAL INSTRUMENT STORES',
  },
  {
    'Four Digit SIC Codes': 5812,
    'Four Digit SIC Code Descriptions': 'EATING PLACES',
  },
  {
    'Four Digit SIC Codes': 5813,
    'Four Digit SIC Code Descriptions': 'DRINKING PLACES',
  },
  {
    'Four Digit SIC Codes': 5912,
    'Four Digit SIC Code Descriptions': 'DRUG STORES AND PROPRIETARY STORES',
  },
  {
    'Four Digit SIC Codes': 5921,
    'Four Digit SIC Code Descriptions': 'LIQUOR STORES',
  },
  {
    'Four Digit SIC Codes': 5932,
    'Four Digit SIC Code Descriptions': 'USED MERCHANDISE STORES',
  },
  {
    'Four Digit SIC Codes': 5941,
    'Four Digit SIC Code Descriptions': 'SPORTING GOODS AND BICYCLE SHOPS',
  },
  {
    'Four Digit SIC Codes': 5942,
    'Four Digit SIC Code Descriptions': 'BOOK STORES',
  },
  {
    'Four Digit SIC Codes': 5943,
    'Four Digit SIC Code Descriptions': 'STATIONERY STORES',
  },
  {
    'Four Digit SIC Codes': 5944,
    'Four Digit SIC Code Descriptions': 'JEWELRY STORES',
  },
  {
    'Four Digit SIC Codes': 5945,
    'Four Digit SIC Code Descriptions': 'HOBBY, TOY, AND GAME SHOPS',
  },
  {
    'Four Digit SIC Codes': 5946,
    'Four Digit SIC Code Descriptions': 'CAMERA AND PHOTOGRAPHIC SUPPLY STORES',
  },
  {
    'Four Digit SIC Codes': 5947,
    'Four Digit SIC Code Descriptions': 'GIFT, NOVELTY, AND SOUVENIR SHOP',
  },
  {
    'Four Digit SIC Codes': 5948,
    'Four Digit SIC Code Descriptions': 'LUGGAGE AND LEATHER GOODS STORES',
  },
  {
    'Four Digit SIC Codes': 5949,
    'Four Digit SIC Code Descriptions': 'SEWING, NEEDLEWORK, AND PIECE GOODS',
  },
  {
    'Four Digit SIC Codes': 5961,
    'Four Digit SIC Code Descriptions': 'CATALOG AND MAIL-ORDER HOUSES',
  },
  {
    'Four Digit SIC Codes': 5962,
    'Four Digit SIC Code Descriptions': 'MERCHANDISING MACHINE OPERATORS',
  },
  {
    'Four Digit SIC Codes': 5963,
    'Four Digit SIC Code Descriptions': 'DIRECT SELLING ESTABLISHMENTS',
  },
  {
    'Four Digit SIC Codes': 5983,
    'Four Digit SIC Code Descriptions': 'FUEL OIL DEALERS',
  },
  {
    'Four Digit SIC Codes': 5984,
    'Four Digit SIC Code Descriptions': 'LIQUEFIED PETROLEUM GAS DEALERS',
  },
  {
    'Four Digit SIC Codes': 5989,
    'Four Digit SIC Code Descriptions': 'FUEL DEALERS, NEC',
  },
  {
    'Four Digit SIC Codes': 5992,
    'Four Digit SIC Code Descriptions': 'FLORISTS',
  },
  {
    'Four Digit SIC Codes': 5993,
    'Four Digit SIC Code Descriptions': 'TOBACCO STORES AND STANDS',
  },
  {
    'Four Digit SIC Codes': 5994,
    'Four Digit SIC Code Descriptions': 'NEWS DEALERS AND NEWSSTANDS',
  },
  {
    'Four Digit SIC Codes': 5995,
    'Four Digit SIC Code Descriptions': 'OPTICAL GOODS STORES',
  },
  {
    'Four Digit SIC Codes': 5999,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS RETAIL STORES, NEC',
  },
  {
    'Four Digit SIC Codes': 6011,
    'Four Digit SIC Code Descriptions': 'FEDERAL RESERVE BANKS',
  },
  {
    'Four Digit SIC Codes': 6019,
    'Four Digit SIC Code Descriptions': 'CENTRAL RESERVE DEPOSITORY, NEC',
  },
  {
    'Four Digit SIC Codes': 6021,
    'Four Digit SIC Code Descriptions': 'NATIONAL COMMERCIAL BANKS',
  },
  {
    'Four Digit SIC Codes': 6022,
    'Four Digit SIC Code Descriptions': 'STATE COMMERCIAL BANKS',
  },
  {
    'Four Digit SIC Codes': 6029,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL BANKS, NEC',
  },
  {
    'Four Digit SIC Codes': 6035,
    'Four Digit SIC Code Descriptions': 'FEDERAL SAVINGS INSTITUTIONS',
  },
  {
    'Four Digit SIC Codes': 6036,
    'Four Digit SIC Code Descriptions': 'SAVINGS INSTITUTIONS, EXCEPT FEDERAL',
  },
  {
    'Four Digit SIC Codes': 6061,
    'Four Digit SIC Code Descriptions': 'FEDERAL CREDIT UNIONS',
  },
  {
    'Four Digit SIC Codes': 6062,
    'Four Digit SIC Code Descriptions': 'STATE CREDIT UNIONS',
  },
  {
    'Four Digit SIC Codes': 6081,
    'Four Digit SIC Code Descriptions': 'FOREIGN BANK AND BRANCHES AND AGENCIES',
  },
  {
    'Four Digit SIC Codes': 6082,
    'Four Digit SIC Code Descriptions': 'FOREIGN TRADE AND INTERNATIONAL BANKS',
  },
  {
    'Four Digit SIC Codes': 6091,
    'Four Digit SIC Code Descriptions': 'NONDEPOSIT TRUST FACILITIES',
  },
  {
    'Four Digit SIC Codes': 6099,
    'Four Digit SIC Code Descriptions': 'FUNCTIONS RELATED TO DEPOSITORY BANKING',
  },
  {
    'Four Digit SIC Codes': 6111,
    'Four Digit SIC Code Descriptions': 'FEDERAL AND FEDERALLY SPONSORED CREDIT',
  },
  {
    'Four Digit SIC Codes': 6141,
    'Four Digit SIC Code Descriptions': 'PERSONAL CREDIT INSTITUTIONS',
  },
  {
    'Four Digit SIC Codes': 6153,
    'Four Digit SIC Code Descriptions': 'SHORT-TERM BUSINESS CREDIT',
  },
  {
    'Four Digit SIC Codes': 6159,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS BUSINESS CREDIT',
  },
  {
    'Four Digit SIC Codes': 6162,
    'Four Digit SIC Code Descriptions': 'MORTGAGE BANKERS AND CORRESPONDENTS',
  },
  {
    'Four Digit SIC Codes': 6163,
    'Four Digit SIC Code Descriptions': 'LOAN BROKERS',
  },
  {
    'Four Digit SIC Codes': 6211,
    'Four Digit SIC Code Descriptions': 'SECURITY BROKERS AND DEALERS',
  },
  {
    'Four Digit SIC Codes': 6221,
    'Four Digit SIC Code Descriptions': 'COMMODITY CONTRACTS BROKERS, DEALERS',
  },
  {
    'Four Digit SIC Codes': 6231,
    'Four Digit SIC Code Descriptions': 'SECURITY AND COMMODITY EXCHANGES',
  },
  {
    'Four Digit SIC Codes': 6282,
    'Four Digit SIC Code Descriptions': 'INVESTMENT ADVICE',
  },
  {
    'Four Digit SIC Codes': 6289,
    'Four Digit SIC Code Descriptions': 'SECURITY AND COMMODITY SERVICE',
  },
  {
    'Four Digit SIC Codes': 6311,
    'Four Digit SIC Code Descriptions': 'LIFE INSURANCE',
  },
  {
    'Four Digit SIC Codes': 6321,
    'Four Digit SIC Code Descriptions': 'ACCIDENT AND HEALTH INSURANCE',
  },
  {
    'Four Digit SIC Codes': 6324,
    'Four Digit SIC Code Descriptions': 'HOSPITAL AND MEDICAL SERVICE PLANS',
  },
  {
    'Four Digit SIC Codes': 6331,
    'Four Digit SIC Code Descriptions': 'FIRE, MARINE, AND CASUALTY INSURANCE',
  },
  {
    'Four Digit SIC Codes': 6351,
    'Four Digit SIC Code Descriptions': 'SURETY INSURANCE',
  },
  {
    'Four Digit SIC Codes': 6361,
    'Four Digit SIC Code Descriptions': 'TITLE INSURANCE',
  },
  {
    'Four Digit SIC Codes': 6371,
    'Four Digit SIC Code Descriptions': 'PENSION, HEALTH, AND WELFARE FUNDS',
  },
  {
    'Four Digit SIC Codes': 6399,
    'Four Digit SIC Code Descriptions': 'INSURANCE CARRIERS, NEC',
  },
  {
    'Four Digit SIC Codes': 6411,
    'Four Digit SIC Code Descriptions': 'INSURANCE AGENTS, BROKERS, AND SERVICE',
  },
  {
    'Four Digit SIC Codes': 6512,
    'Four Digit SIC Code Descriptions': 'NONRESIDENTIAL BUILDING OPERATORS',
  },
  {
    'Four Digit SIC Codes': 6513,
    'Four Digit SIC Code Descriptions': 'APARTMENT BUILDING OPERATORS',
  },
  {
    'Four Digit SIC Codes': 6514,
    'Four Digit SIC Code Descriptions': 'DWELLING OPERATORS, EXCEPT APARTMENTS',
  },
  {
    'Four Digit SIC Codes': 6515,
    'Four Digit SIC Code Descriptions': 'MOBILE HOME SITE OPERATORS',
  },
  {
    'Four Digit SIC Codes': 6517,
    'Four Digit SIC Code Descriptions': 'RAILROAD PROPERTY LESSORS',
  },
  {
    'Four Digit SIC Codes': 6519,
    'Four Digit SIC Code Descriptions': 'REAL PROPERTY LESSORS, NEC',
  },
  {
    'Four Digit SIC Codes': 6531,
    'Four Digit SIC Code Descriptions': 'REAL ESTATE AGENTS AND MANAGERS',
  },
  {
    'Four Digit SIC Codes': 6541,
    'Four Digit SIC Code Descriptions': 'TITLE ABSTRACT OFFICES',
  },
  {
    'Four Digit SIC Codes': 6552,
    'Four Digit SIC Code Descriptions': 'SUBDIVIDERS AND DEVELOPERS, NEC',
  },
  {
    'Four Digit SIC Codes': 6553,
    'Four Digit SIC Code Descriptions': 'CEMETERY SUBDIVIDERS AND DEVELOPERS',
  },
  {
    'Four Digit SIC Codes': 6712,
    'Four Digit SIC Code Descriptions': 'BANK HOLDING COMPANIES',
  },
  {
    'Four Digit SIC Codes': 6719,
    'Four Digit SIC Code Descriptions': 'HOLDING COMPANIES, NEC',
  },
  {
    'Four Digit SIC Codes': 6722,
    'Four Digit SIC Code Descriptions': 'MANAGEMENT INVESTMENT, OPEN-ENDED',
  },
  {
    'Four Digit SIC Codes': 6726,
    'Four Digit SIC Code Descriptions': 'INVESTMENT OFFICES, NEC',
  },
  {
    'Four Digit SIC Codes': 6732,
    'Four Digit SIC Code Descriptions': 'TRUSTS: EDUCATIONAL, RELIGIOUS, ETC.',
  },
  {
    'Four Digit SIC Codes': 6733,
    'Four Digit SIC Code Descriptions': 'TRUSTS, NEC',
  },
  {
    'Four Digit SIC Codes': 6792,
    'Four Digit SIC Code Descriptions': 'OIL ROYALTY TRADERS',
  },
  {
    'Four Digit SIC Codes': 6794,
    'Four Digit SIC Code Descriptions': 'PATENT OWNERS AND LESSORS',
  },
  {
    'Four Digit SIC Codes': 6798,
    'Four Digit SIC Code Descriptions': 'REAL ESTATE INVESTMENT TRUSTS',
  },
  {
    'Four Digit SIC Codes': 6799,
    'Four Digit SIC Code Descriptions': 'INVESTORS, NEC',
  },
  {
    'Four Digit SIC Codes': 7011,
    'Four Digit SIC Code Descriptions': 'HOTELS AND MOTELS',
  },
  {
    'Four Digit SIC Codes': 7021,
    'Four Digit SIC Code Descriptions': 'ROOMING AND BOARDING HOUSES',
  },
  {
    'Four Digit SIC Codes': 7032,
    'Four Digit SIC Code Descriptions': 'SPORTING AND RECREATIONAL CAMPS',
  },
  {
    'Four Digit SIC Codes': 7033,
    'Four Digit SIC Code Descriptions': 'TRAILER PARKS AND CAMPSITES',
  },
  {
    'Four Digit SIC Codes': 7041,
    'Four Digit SIC Code Descriptions': 'MEMBERSHIP-BASIS ORGANIZATION HOTELS',
  },
  {
    'Four Digit SIC Codes': 7211,
    'Four Digit SIC Code Descriptions': 'POWER LAUNDRIES, FAMILY AND COMMERCIAL',
  },
  {
    'Four Digit SIC Codes': 7212,
    'Four Digit SIC Code Descriptions': "GARMENT PRESSING AND CLEANERS' AGENTS",
  },
  {
    'Four Digit SIC Codes': 7213,
    'Four Digit SIC Code Descriptions': 'LINEN SUPPLY',
  },
  {
    'Four Digit SIC Codes': 7215,
    'Four Digit SIC Code Descriptions': 'COIN-OPERATED LAUNDRIES AND CLEANING',
  },
  {
    'Four Digit SIC Codes': 7216,
    'Four Digit SIC Code Descriptions': 'DRYCLEANING PLANTS, EXCEPT RUGS',
  },
  {
    'Four Digit SIC Codes': 7217,
    'Four Digit SIC Code Descriptions': 'CARPET AND UPHOLSTERY CLEANING',
  },
  {
    'Four Digit SIC Codes': 7218,
    'Four Digit SIC Code Descriptions': 'INDUSTRIAL LAUNDERERS',
  },
  {
    'Four Digit SIC Codes': 7219,
    'Four Digit SIC Code Descriptions': 'LAUNDRY AND GARMENT SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 7221,
    'Four Digit SIC Code Descriptions': 'PHOTOGRAPHIC STUDIOS, PORTRAIT',
  },
  {
    'Four Digit SIC Codes': 7231,
    'Four Digit SIC Code Descriptions': 'BEAUTY SHOPS',
  },
  {
    'Four Digit SIC Codes': 7241,
    'Four Digit SIC Code Descriptions': 'BARBER SHOPS',
  },
  {
    'Four Digit SIC Codes': 7251,
    'Four Digit SIC Code Descriptions': 'SHOE REPAIR AND SHOESHINE PARLORS',
  },
  {
    'Four Digit SIC Codes': 7261,
    'Four Digit SIC Code Descriptions': 'FUNERAL SERVICE AND CREMATORIES',
  },
  {
    'Four Digit SIC Codes': 7291,
    'Four Digit SIC Code Descriptions': 'TAX RETURN PREPARATION SERVICES',
  },
  {
    'Four Digit SIC Codes': 7299,
    'Four Digit SIC Code Descriptions': 'MISCELLANEOUS PERSONAL SERVICES',
  },
  {
    'Four Digit SIC Codes': 7311,
    'Four Digit SIC Code Descriptions': 'ADVERTISING AGENCIES',
  },
  {
    'Four Digit SIC Codes': 7312,
    'Four Digit SIC Code Descriptions': 'OUTDOOR ADVERTISING SERVICES',
  },
  {
    'Four Digit SIC Codes': 7313,
    'Four Digit SIC Code Descriptions': 'RADIO, TELEVISION, PUBLISHER REPRESENTATIVES',
  },
  {
    'Four Digit SIC Codes': 7319,
    'Four Digit SIC Code Descriptions': 'ADVERTISING, NEC',
  },
  {
    'Four Digit SIC Codes': 7322,
    'Four Digit SIC Code Descriptions': 'ADJUSTMENT AND COLLECTION SERVICES',
  },
  {
    'Four Digit SIC Codes': 7323,
    'Four Digit SIC Code Descriptions': 'CREDIT REPORTING SERVICES',
  },
  {
    'Four Digit SIC Codes': 7331,
    'Four Digit SIC Code Descriptions': 'DIRECT MAIL ADVERTISING SERVICES',
  },
  {
    'Four Digit SIC Codes': 7334,
    'Four Digit SIC Code Descriptions': 'PHOTOCOPYING AND DUPLICATING SERVICES',
  },
  {
    'Four Digit SIC Codes': 7335,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL PHOTOGRAPHY',
  },
  {
    'Four Digit SIC Codes': 7336,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL ART AND GRAPHIC DESIGN',
  },
  {
    'Four Digit SIC Codes': 7338,
    'Four Digit SIC Code Descriptions': 'SECRETARIAL AND COURT REPORTING',
  },
  {
    'Four Digit SIC Codes': 7342,
    'Four Digit SIC Code Descriptions': 'DISINFECTING AND PEST CONTROL SERVICES',
  },
  {
    'Four Digit SIC Codes': 7349,
    'Four Digit SIC Code Descriptions': 'BUILDING MAINTENANCE SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 7352,
    'Four Digit SIC Code Descriptions': 'MEDICAL EQUIPMENT RENTAL',
  },
  {
    'Four Digit SIC Codes': 7353,
    'Four Digit SIC Code Descriptions': 'HEAVY CONSTRUCTION EQUIPMENT RENTAL',
  },
  {
    'Four Digit SIC Codes': 7359,
    'Four Digit SIC Code Descriptions': 'EQUIPMENT RENTAL AND LEASING, NEC',
  },
  {
    'Four Digit SIC Codes': 7361,
    'Four Digit SIC Code Descriptions': 'EMPLOYMENT AGENCIES',
  },
  {
    'Four Digit SIC Codes': 7363,
    'Four Digit SIC Code Descriptions': 'HELP SUPPLY SERVICES',
  },
  {
    'Four Digit SIC Codes': 7371,
    'Four Digit SIC Code Descriptions': 'CUSTOM COMPUTER PROGRAMMING SERVICES',
  },
  {
    'Four Digit SIC Codes': 7372,
    'Four Digit SIC Code Descriptions': 'PREPACKAGED SOFTWARE',
  },
  {
    'Four Digit SIC Codes': 7373,
    'Four Digit SIC Code Descriptions': 'COMPUTER INTEGRATED SYSTEMS DESIGN',
  },
  {
    'Four Digit SIC Codes': 7374,
    'Four Digit SIC Code Descriptions': 'DATA PROCESSING AND PREPARATION',
  },
  {
    'Four Digit SIC Codes': 7375,
    'Four Digit SIC Code Descriptions': 'INFORMATION RETRIEVAL SERVICES',
  },
  {
    'Four Digit SIC Codes': 7376,
    'Four Digit SIC Code Descriptions': 'COMPUTER FACILITIES MANAGEMENT',
  },
  {
    'Four Digit SIC Codes': 7377,
    'Four Digit SIC Code Descriptions': 'COMPUTER RENTAL AND LEASING',
  },
  {
    'Four Digit SIC Codes': 7378,
    'Four Digit SIC Code Descriptions': 'COMPUTER MAINTENANCE AND REPAIR',
  },
  {
    'Four Digit SIC Codes': 7379,
    'Four Digit SIC Code Descriptions': 'COMPUTER RELATED SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 7381,
    'Four Digit SIC Code Descriptions': 'DETECTIVE AND ARMORED CAR SERVICES',
  },
  {
    'Four Digit SIC Codes': 7382,
    'Four Digit SIC Code Descriptions': 'SECURITY SYSTEMS SERVICES',
  },
  {
    'Four Digit SIC Codes': 7383,
    'Four Digit SIC Code Descriptions': 'NEWS SYNDICATES',
  },
  {
    'Four Digit SIC Codes': 7384,
    'Four Digit SIC Code Descriptions': 'PHOTOFINISH LABORATORIES',
  },
  {
    'Four Digit SIC Codes': 7389,
    'Four Digit SIC Code Descriptions': 'BUSINESS SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 7513,
    'Four Digit SIC Code Descriptions': 'TRUCK RENTAL AND LEASING, WITHOUT DRIVERS',
  },
  {
    'Four Digit SIC Codes': 7514,
    'Four Digit SIC Code Descriptions': 'PASSENGER CAR RENTAL',
  },
  {
    'Four Digit SIC Codes': 7515,
    'Four Digit SIC Code Descriptions': 'PASSENGER CAR LEASING',
  },
  {
    'Four Digit SIC Codes': 7519,
    'Four Digit SIC Code Descriptions': 'UTILITY TRAILER RENTAL',
  },
  {
    'Four Digit SIC Codes': 7521,
    'Four Digit SIC Code Descriptions': 'AUTOMOBILE PARKING',
  },
  {
    'Four Digit SIC Codes': 7532,
    'Four Digit SIC Code Descriptions': 'TOP AND BODY REPAIR AND PAINT SHOPS',
  },
  {
    'Four Digit SIC Codes': 7533,
    'Four Digit SIC Code Descriptions': 'AUTO EXHAUST SYSTEM REPAIR SHOPS',
  },
  {
    'Four Digit SIC Codes': 7534,
    'Four Digit SIC Code Descriptions': 'TIRE RETREADING AND REPAIR SHOPS',
  },
  {
    'Four Digit SIC Codes': 7536,
    'Four Digit SIC Code Descriptions': 'AUTOMOTIVE GLASS REPLACEMENT SHOPS',
  },
  {
    'Four Digit SIC Codes': 7537,
    'Four Digit SIC Code Descriptions': 'AUTOMOTIVE TRANSMISSION REPAIR SHOPS',
  },
  {
    'Four Digit SIC Codes': 7538,
    'Four Digit SIC Code Descriptions': 'GENERAL AUTOMOTIVE REPAIR SHOPS',
  },
  {
    'Four Digit SIC Codes': 7539,
    'Four Digit SIC Code Descriptions': 'AUTOMOTIVE REPAIR SHOPS, NEC',
  },
  {
    'Four Digit SIC Codes': 7542,
    'Four Digit SIC Code Descriptions': 'CARWASHES',
  },
  {
    'Four Digit SIC Codes': 7549,
    'Four Digit SIC Code Descriptions': 'AUTOMOTIVE SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 7622,
    'Four Digit SIC Code Descriptions': 'RADIO AND TELEVISION REPAIR',
  },
  {
    'Four Digit SIC Codes': 7623,
    'Four Digit SIC Code Descriptions': 'REFRIGERATION SERVICE AND REPAIR',
  },
  {
    'Four Digit SIC Codes': 7629,
    'Four Digit SIC Code Descriptions': 'ELECTRICAL REPAIR SHOPS',
  },
  {
    'Four Digit SIC Codes': 7631,
    'Four Digit SIC Code Descriptions': 'WATCH, CLOCK, AND JEWELRY REPAIR',
  },
  {
    'Four Digit SIC Codes': 7641,
    'Four Digit SIC Code Descriptions': 'REUPHOLSTERY AND FURNITURE REPAIR',
  },
  {
    'Four Digit SIC Codes': 7692,
    'Four Digit SIC Code Descriptions': 'WELDING REPAIR',
  },
  {
    'Four Digit SIC Codes': 7694,
    'Four Digit SIC Code Descriptions': 'ARMATURE REWINDING SHOPS',
  },
  {
    'Four Digit SIC Codes': 7699,
    'Four Digit SIC Code Descriptions': 'REPAIR SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 7812,
    'Four Digit SIC Code Descriptions': 'MOTION PICTURE AND VIDEO PRODUCTION',
  },
  {
    'Four Digit SIC Codes': 7819,
    'Four Digit SIC Code Descriptions': 'SERVICES ALLIED TO MOTION PICTURES',
  },
  {
    'Four Digit SIC Codes': 7822,
    'Four Digit SIC Code Descriptions': 'MOTION PICTURE AND TAPE DISTRIBUTION',
  },
  {
    'Four Digit SIC Codes': 7829,
    'Four Digit SIC Code Descriptions': 'MOTION PICTURE DISTRIBUTION SERVICES',
  },
  {
    'Four Digit SIC Codes': 7832,
    'Four Digit SIC Code Descriptions': 'MOTION PICTURE THEATERS, EXCEPT DRIVE-IN',
  },
  {
    'Four Digit SIC Codes': 7833,
    'Four Digit SIC Code Descriptions': 'DRIVE-IN MOTION PICTURE THEATERS',
  },
  {
    'Four Digit SIC Codes': 7841,
    'Four Digit SIC Code Descriptions': 'VIDEO TAPE RENTAL',
  },
  {
    'Four Digit SIC Codes': 7911,
    'Four Digit SIC Code Descriptions': 'DANCE STUDIOS, SCHOOLS, AND HALLS',
  },
  {
    'Four Digit SIC Codes': 7922,
    'Four Digit SIC Code Descriptions': 'THEATRICAL PRODUCERS AND SERVICES',
  },
  {
    'Four Digit SIC Codes': 7929,
    'Four Digit SIC Code Descriptions': 'ENTERTAINERS AND ENTERTAINMENT GROUPS',
  },
  {
    'Four Digit SIC Codes': 7933,
    'Four Digit SIC Code Descriptions': 'BOWLING CENTERS',
  },
  {
    'Four Digit SIC Codes': 7941,
    'Four Digit SIC Code Descriptions': 'SPORTS CLUBS, MANAGERS, AND PROMOTERS',
  },
  {
    'Four Digit SIC Codes': 7948,
    'Four Digit SIC Code Descriptions': 'RACING, INCLUDING TRACK OPERATION',
  },
  {
    'Four Digit SIC Codes': 7991,
    'Four Digit SIC Code Descriptions': 'PHYSICAL FITNESS FACILITIES',
  },
  {
    'Four Digit SIC Codes': 7992,
    'Four Digit SIC Code Descriptions': 'PUBLIC GOLF COURSES',
  },
  {
    'Four Digit SIC Codes': 7993,
    'Four Digit SIC Code Descriptions': 'COIN-OPERATED AMUSEMENT DEVICES',
  },
  {
    'Four Digit SIC Codes': 7996,
    'Four Digit SIC Code Descriptions': 'AMUSEMENT PARKS',
  },
  {
    'Four Digit SIC Codes': 7997,
    'Four Digit SIC Code Descriptions': 'MEMBERSHIP SPORTS AND RECREATION CLUBS',
  },
  {
    'Four Digit SIC Codes': 7999,
    'Four Digit SIC Code Descriptions': 'AMUSEMENT AND RECREATION, NEC',
  },
  {
    'Four Digit SIC Codes': 8011,
    'Four Digit SIC Code Descriptions': 'OFFICES AND CLINICS OF MEDICAL DOCTORS',
  },
  {
    'Four Digit SIC Codes': 8021,
    'Four Digit SIC Code Descriptions': 'OFFICES AND CLINICS OF DENTISTS',
  },
  {
    'Four Digit SIC Codes': 8031,
    'Four Digit SIC Code Descriptions': 'OFFICES AND CLINICS OF OSTEOPATHIC PHYSICIANS',
  },
  {
    'Four Digit SIC Codes': 8041,
    'Four Digit SIC Code Descriptions': 'OFFICES AND CLINICS OF CHIROPRACTORS',
  },
  {
    'Four Digit SIC Codes': 8042,
    'Four Digit SIC Code Descriptions': 'OFFICES AND CLINICS OF OPTOMETRISTS',
  },
  {
    'Four Digit SIC Codes': 8043,
    'Four Digit SIC Code Descriptions': 'OFFICES AND CLINICS OF PODIATRISTS',
  },
  {
    'Four Digit SIC Codes': 8049,
    'Four Digit SIC Code Descriptions': 'OFFICES OF HEALTH PRACTITIONER',
  },
  {
    'Four Digit SIC Codes': 8051,
    'Four Digit SIC Code Descriptions': 'SKILLED NURSING CARE FACILITIES',
  },
  {
    'Four Digit SIC Codes': 8052,
    'Four Digit SIC Code Descriptions': 'INTERMEDIATE CARE FACILITIES',
  },
  {
    'Four Digit SIC Codes': 8059,
    'Four Digit SIC Code Descriptions': 'NURSING AND PERSONAL CARE, NEC',
  },
  {
    'Four Digit SIC Codes': 8062,
    'Four Digit SIC Code Descriptions': 'GENERAL MEDICAL AND SURGICAL HOSPITALS',
  },
  {
    'Four Digit SIC Codes': 8063,
    'Four Digit SIC Code Descriptions': 'PSYCHIATRIC HOSPITALS',
  },
  {
    'Four Digit SIC Codes': 8069,
    'Four Digit SIC Code Descriptions': 'SPECIALTY HOSPITALS, EXCEPT PSYCHIATRIC',
  },
  {
    'Four Digit SIC Codes': 8071,
    'Four Digit SIC Code Descriptions': 'MEDICAL LABORATORIES',
  },
  {
    'Four Digit SIC Codes': 8072,
    'Four Digit SIC Code Descriptions': 'DENTAL LABORATORIES',
  },
  {
    'Four Digit SIC Codes': 8082,
    'Four Digit SIC Code Descriptions': 'HOME HEALTH CARE SERVICES',
  },
  {
    'Four Digit SIC Codes': 8092,
    'Four Digit SIC Code Descriptions': 'KIDNEY DIALYSIS CENTERS',
  },
  {
    'Four Digit SIC Codes': 8093,
    'Four Digit SIC Code Descriptions': 'SPECIALTY OUTPATIENT CLINICS, NEC',
  },
  {
    'Four Digit SIC Codes': 8099,
    'Four Digit SIC Code Descriptions': 'HEALTH AND ALLIED SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 8111,
    'Four Digit SIC Code Descriptions': 'LEGAL SERVICES',
  },
  {
    'Four Digit SIC Codes': 8211,
    'Four Digit SIC Code Descriptions': 'ELEMENTARY AND SECONDARY SCHOOLS',
  },
  {
    'Four Digit SIC Codes': 8221,
    'Four Digit SIC Code Descriptions': 'COLLEGES AND UNIVERSITIES',
  },
  {
    'Four Digit SIC Codes': 8222,
    'Four Digit SIC Code Descriptions': 'JUNIOR COLLEGES',
  },
  {
    'Four Digit SIC Codes': 8231,
    'Four Digit SIC Code Descriptions': 'LIBRARIES',
  },
  {
    'Four Digit SIC Codes': 8243,
    'Four Digit SIC Code Descriptions': 'DATA PROCESSING SCHOOLS',
  },
  {
    'Four Digit SIC Codes': 8244,
    'Four Digit SIC Code Descriptions': 'BUSINESS AND SECRETARIAL SCHOOLS',
  },
  {
    'Four Digit SIC Codes': 8249,
    'Four Digit SIC Code Descriptions': 'VOCATIONAL SCHOOLS, NEC',
  },
  {
    'Four Digit SIC Codes': 8299,
    'Four Digit SIC Code Descriptions': 'SCHOOLS AND EDUCATIONAL SERVICES',
  },
  {
    'Four Digit SIC Codes': 8322,
    'Four Digit SIC Code Descriptions': 'INDIVIDUAL AND FAMILY SERVICES',
  },
  {
    'Four Digit SIC Codes': 8331,
    'Four Digit SIC Code Descriptions': 'JOB TRAINING AND RELATED SERVICES',
  },
  {
    'Four Digit SIC Codes': 8351,
    'Four Digit SIC Code Descriptions': 'CHILD DAY CARE SERVICES',
  },
  {
    'Four Digit SIC Codes': 8361,
    'Four Digit SIC Code Descriptions': 'RESIDENTIAL CARE',
  },
  {
    'Four Digit SIC Codes': 8399,
    'Four Digit SIC Code Descriptions': 'SOCIAL SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 8412,
    'Four Digit SIC Code Descriptions': 'MUSEUMS AND ART GALLERIES',
  },
  {
    'Four Digit SIC Codes': 8422,
    'Four Digit SIC Code Descriptions': 'BOTANICAL AND ZOOLOGICAL GARDENS',
  },
  {
    'Four Digit SIC Codes': 8611,
    'Four Digit SIC Code Descriptions': 'BUSINESS ASSOCIATIONS',
  },
  {
    'Four Digit SIC Codes': 8621,
    'Four Digit SIC Code Descriptions': 'PROFESSIONAL ORGANIZATIONS',
  },
  {
    'Four Digit SIC Codes': 8631,
    'Four Digit SIC Code Descriptions': 'LABOR ORGANIZATIONS',
  },
  {
    'Four Digit SIC Codes': 8641,
    'Four Digit SIC Code Descriptions': 'CIVIC AND SOCIAL ASSOCIATIONS',
  },
  {
    'Four Digit SIC Codes': 8651,
    'Four Digit SIC Code Descriptions': 'POLITICAL ORGANIZATIONS',
  },
  {
    'Four Digit SIC Codes': 8661,
    'Four Digit SIC Code Descriptions': 'RELIGIOUS ORGANIZATIONS',
  },
  {
    'Four Digit SIC Codes': 8699,
    'Four Digit SIC Code Descriptions': 'MEMBERSHIP ORGANIZATIONS, NEC',
  },
  {
    'Four Digit SIC Codes': 8711,
    'Four Digit SIC Code Descriptions': 'ENGINEERING SERVICES',
  },
  {
    'Four Digit SIC Codes': 8712,
    'Four Digit SIC Code Descriptions': 'ARCHITECTURAL SERVICES',
  },
  {
    'Four Digit SIC Codes': 8713,
    'Four Digit SIC Code Descriptions': 'SURVEYING SERVICES',
  },
  {
    'Four Digit SIC Codes': 8721,
    'Four Digit SIC Code Descriptions': 'ACCOUNTING, AUDITING, AND BOOKKEEPING',
  },
  {
    'Four Digit SIC Codes': 8731,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL PHYSICAL RESEARCH',
  },
  {
    'Four Digit SIC Codes': 8732,
    'Four Digit SIC Code Descriptions': 'COMMERCIAL NONPHYSICAL RESEARCH',
  },
  {
    'Four Digit SIC Codes': 8733,
    'Four Digit SIC Code Descriptions': 'NONCOMMERCIAL RESEARCH ORGANIZATIONS',
  },
  {
    'Four Digit SIC Codes': 8734,
    'Four Digit SIC Code Descriptions': 'TESTING LABORATORIES',
  },
  {
    'Four Digit SIC Codes': 8741,
    'Four Digit SIC Code Descriptions': 'MANAGEMENT SERVICES',
  },
  {
    'Four Digit SIC Codes': 8742,
    'Four Digit SIC Code Descriptions': 'MANAGEMENT CONSULTING SERVICES',
  },
  {
    'Four Digit SIC Codes': 8743,
    'Four Digit SIC Code Descriptions': 'PUBLIC RELATIONS SERVICES',
  },
  {
    'Four Digit SIC Codes': 8744,
    'Four Digit SIC Code Descriptions': 'FACILITIES SUPPORT SERVICES',
  },
  {
    'Four Digit SIC Codes': 8748,
    'Four Digit SIC Code Descriptions': 'BUSINESS CONSULTING, NEC',
  },
  {
    'Four Digit SIC Codes': 8999,
    'Four Digit SIC Code Descriptions': 'SERVICES, NEC',
  },
  {
    'Four Digit SIC Codes': 9111,
    'Four Digit SIC Code Descriptions': 'EXECUTIVE OFFICES',
  },
  {
    'Four Digit SIC Codes': 9121,
    'Four Digit SIC Code Descriptions': 'LEGISLATIVE BODIES',
  },
  {
    'Four Digit SIC Codes': 9131,
    'Four Digit SIC Code Descriptions': 'EXECUTIVE AND LEGISLATIVE COMBINED',
  },
  {
    'Four Digit SIC Codes': 9199,
    'Four Digit SIC Code Descriptions': 'GENERAL GOVERNMENT, NEC',
  },
  {
    'Four Digit SIC Codes': 9211,
    'Four Digit SIC Code Descriptions': 'COURTS',
  },
  {
    'Four Digit SIC Codes': 9221,
    'Four Digit SIC Code Descriptions': 'POLICE PROTECTION',
  },
  {
    'Four Digit SIC Codes': 9222,
    'Four Digit SIC Code Descriptions': 'LEGAL COUNSEL AND PROSECUTION',
  },
  {
    'Four Digit SIC Codes': 9223,
    'Four Digit SIC Code Descriptions': 'CORRECTIONAL INSTITUTIONS',
  },
  {
    'Four Digit SIC Codes': 9224,
    'Four Digit SIC Code Descriptions': 'FIRE PROTECTION',
  },
  {
    'Four Digit SIC Codes': 9229,
    'Four Digit SIC Code Descriptions': 'PUBLIC ORDER AND SAFETY, NEC',
  },
  {
    'Four Digit SIC Codes': 9311,
    'Four Digit SIC Code Descriptions': 'FINANCE, TAXATION, AND MONETARY POLICY',
  },
  {
    'Four Digit SIC Codes': 9411,
    'Four Digit SIC Code Descriptions': 'ADMINISTRATION OF EDUCATIONAL PROGRAMS',
  },
  {
    'Four Digit SIC Codes': 9431,
    'Four Digit SIC Code Descriptions': 'ADMINISTRATION OF PUBLIC HEALTH PROGRAMS',
  },
  {
    'Four Digit SIC Codes': 9441,
    'Four Digit SIC Code Descriptions': 'ADMINISTRATION OF SOCIAL AND MANPOWER PROGRAMS',
  },
  {
    'Four Digit SIC Codes': 9451,
    'Four Digit SIC Code Descriptions': "ADMINISTRATION OF VETERANS' AFFAIRS",
  },
  {
    'Four Digit SIC Codes': 9511,
    'Four Digit SIC Code Descriptions': 'AIR, WATER, AND SOLID WASTE MANAGEMENT',
  },
  {
    'Four Digit SIC Codes': 9512,
    'Four Digit SIC Code Descriptions': 'LAND, MINERAL, AND WILDLIFE CONSERVATION',
  },
  {
    'Four Digit SIC Codes': 9531,
    'Four Digit SIC Code Descriptions': 'HOUSING PROGRAMS',
  },
  {
    'Four Digit SIC Codes': 9532,
    'Four Digit SIC Code Descriptions': 'URBAN AND COMMUNITY DEVELOPMENT',
  },
  {
    'Four Digit SIC Codes': 9611,
    'Four Digit SIC Code Descriptions': 'ADMINISTRATION OF GENERAL ECONOMIC PROGRAMS',
  },
  {
    'Four Digit SIC Codes': 9621,
    'Four Digit SIC Code Descriptions': 'REGULATION, ADMINISTRATION OF TRANSPORTATION',
  },
  {
    'Four Digit SIC Codes': 9631,
    'Four Digit SIC Code Descriptions': 'REGULATION, ADMINISTRATION OF UTILITIES',
  },
  {
    'Four Digit SIC Codes': 9641,
    'Four Digit SIC Code Descriptions': 'REGULATION OF AGRICULTURAL MARKETING',
  },
  {
    'Four Digit SIC Codes': 9651,
    'Four Digit SIC Code Descriptions': 'REGULATION, MISCELLANEOUS COMMERCIAL SECTORS',
  },
  {
    'Four Digit SIC Codes': 9661,
    'Four Digit SIC Code Descriptions': 'SPACE RESEARCH AND TECHNOLOGY',
  },
  {
    'Four Digit SIC Codes': 9711,
    'Four Digit SIC Code Descriptions': 'NATIONAL SECURITY',
  },
  {
    'Four Digit SIC Codes': 9721,
    'Four Digit SIC Code Descriptions': 'INTERNATIONAL AFFAIRS',
  },
  {
    'Four Digit SIC Codes': 9999,
    'Four Digit SIC Code Descriptions': 'NONCLASSIFIABLE ESTABLISHMENTS',
  },
];

export default sicCodes;
